// -----------------desgin 1------------------



// import React, { useState, useEffect } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//   CheckCircle,
//   PlayCircleOutline as PlayCircle,
//   EmojiEvents as Trophy,
//   MenuBook as Book,
//   Group as Users,
//   Person,
//   Grade,
//   Lightbulb,
//   MessageRounded,
// } from '@mui/icons-material';
// import {
//   Typography,
//   LinearProgress,
//   Grid,
//   Paper,
//   Button,
//   List,
//   ListItemButton,
//   ListItemText,
//   ListItemIcon,
//   Checkbox,
//   Card,
//   CardContent,
//   CardMedia,
//   Avatar,
//   Box,
// } from '@mui/material';
// import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';

// // Mock data
// const mockVideos = [
//   { id: 1, title: 'Intro', url: '#', completed: false, thumbnail: 'https://placehold.co/400x240/EEE/31343C?text=Intro' },
//   { id: 2, title: 'Module 1', url: '#', completed: false, thumbnail: 'https://placehold.co/400x240/EEE/31343C?text=Module+1' },
//   { id: 3, title: 'Module 2', url: '#', completed: false, thumbnail: 'https://placehold.co/400x240/EEE/31343C?text=Module+2' },
//   { id: 4, title: 'Module 3', url: '#', completed: false, thumbnail: 'https://placehold.co/400x240/EEE/31343C?text=Module+3' },
// ];

// const mockUser = { name: 'Learner', avatar: 'https://placehold.co/60x60/EEE/31343C?text=AL', level: 5, points: 420 };

// // Theme
// const theme = createTheme({
//   palette: { primary: { main: '#6c63ff' }, secondary: { main: '#f44336' }, background: { default: '#f0f0f0', paper: '#ffffff' }, text: { primary: '#333', secondary: '#666' } },
//   typography: { fontFamily: '"Open Sans", sans-serif', h1: { fontWeight: 700, fontSize: '2.5rem', color: '#222' }, h2: { fontWeight: 600, fontSize: '2rem', color: '#222' }, h3: { fontWeight: 600, fontSize: '1.5rem', color: '#333' }, h4: { fontWeight: 600, fontSize: '1.2rem', color: '#444' }, h5: { fontWeight: 600, fontSize: '1rem', color: '#444' }, h6: { fontWeight: 500, fontSize: '0.9rem', color: '#555' }, body1: { fontSize: '1rem', color: '#333' }, body2: { fontSize: '0.9rem', color: '#444' }, caption: { fontSize: '0.8rem', color: '#666' }, button: { fontWeight: 600, textTransform: 'capitalize' } },
//   components: {
//     MuiButton: { styleOverrides: { root: { borderRadius: '8px', padding: '10px 20px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', '&:hover': { boxShadow: '0 3px 7px rgba(0,0,0,0.15)' } }, contained: { backgroundColor: '#6c63ff', color: '#fff', '&:hover': { backgroundColor: '#5a52d4' } }, outlined: { borderColor: '#6c63ff', color: '#6c63ff', '&:hover': { backgroundColor: 'rgba(108, 99, 255, 0.08)' } }, text: { color: '#6c63ff', '&:hover': { backgroundColor: 'rgba(108, 99, 255, 0.08)' } }, sizeSmall: { padding: '6px 12px', fontSize: '0.8rem' }, sizeLarge: { padding: '12px 24px', fontSize: '1.1rem' } } },
//     MuiCard: { styleOverrides: { root: { borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' } } },
//     MuiCardContent: { styleOverrides: { root: { padding: '16px' } } },
//     MuiPaper: { styleOverrides: { root: { borderRadius: '12px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)', border: '1px solid #e0e0e0' } } },
//     MuiListItemButton: { styleOverrides: { root: { borderRadius: '8px', '&:hover': { backgroundColor: '#f5f5f5' } } } },
//     MuiLinearProgress: { styleOverrides: { root: { borderRadius: '8px', height: '10px' } } },
//   },
// });

// // Styled Components
// const Title = styled(Typography)(({ theme }) => ({ fontWeight: 700, color: theme.palette.primary.main, marginBottom: theme.spacing(3), textAlign: 'center', fontSize: '2.2rem' }));
// const VideoCardStyled = styled(Card)(({ theme }) => ({ transition: 'transform 0.3s, box-shadow 0.3s', '&:hover': { transform: 'scale(1.03)', boxShadow: '0 6px 18px rgba(0,0,0,0.15)' } }));
// const VideoCardMediaStyled = styled(CardMedia)({ aspectRatio: '16 / 9', borderRadius: '12px', objectFit: 'cover', cursor: 'pointer' });
// const PlayButtonStyled = styled(Button)(({ theme }) => ({ backgroundColor: '#fff', color: theme.palette.primary.main, borderRadius: '50%', width: 60, height: 60, minWidth: 0, padding: 0, boxShadow: '0 3px 7px rgba(0,0,0,0.15)', transition: 'transform 0.2s, background-color 0.2s', '&:hover': { transform: 'scale(1.1)', backgroundColor: '#f8f8f8' } }));
// const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({ borderRadius: 12, margin: `${theme.spacing(0.5)} 0`, paddingRight: theme.spacing(1), transition: 'background-color 0.3s, transform 0.2s', '&:hover': { backgroundColor: '#f8f8f8', transform: 'translateX(4px)' } }));
// const CertificatePaper = styled(Paper)(({ theme }) => ({ marginTop: theme.spacing(4), padding: theme.spacing(3), textAlign: 'center', borderRadius: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.15)', border: '1px solid #e0e0e0' }));
// const DownloadButton = styled(Button)(({ theme }) => ({ backgroundColor: '#4caf50', color: '#fff', '&:hover': { backgroundColor: '#43a047' }, borderRadius: 8, padding: theme.spacing(1.5, 3), fontWeight: 600 }));
// const UserProfileCard = styled(Card)(({ theme }) => ({ backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderRadius: 12, padding: theme.spacing(2), border: '1px solid #e0e0e0' }));
// const FunFactPaper = styled(Paper)(({ theme }) => ({ padding: theme.spacing(2), marginTop: theme.spacing(2), borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0', backgroundColor: '#fff' }));

// // Components
// const CertificateSection = ({ completedCount, required }) => {
//   const isUnlocked = completedCount >= required;
//   return (
//     <CertificatePaper>
//       <Typography variant="h4" sx={{ color: '#ffc107' }}>
//         <Trophy sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.5rem' }} /> Course Certificate
//       </Typography>
//       <AnimatePresence>
//         {isUnlocked ? (
//           <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} exit={{ opacity: 0, scale: 0.5 }}>
//             <CheckCircle color="success" sx={{ fontSize: 60, mb: 2, color: '#4caf50' }} />
//             <Typography variant="h6" gutterBottom>
//               Completed {completedCount} videos.
//             </Typography>
//             <DownloadButton variant="contained">Download</DownloadButton>
//           </motion.div>
//         ) : (
//           <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }} exit={{ opacity: 0, y: -20 }}>
//             <Typography variant="body1">Complete {required} videos to unlock.</Typography>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </CertificatePaper>
//   );
// };

// const VideoList = ({ videos, setCurrentVideo }) => (
//   <Paper sx={{ p: 2, borderRadius: 12, backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' }}>
//     <Typography variant="h5" sx={{ mb: 2, color: '#34495e', fontWeight: 600, textAlign: 'center' }}>
//       <Book sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.2rem' }} /> Course Content
//     </Typography>
//     <List>
//       {videos.map((video) => (
//         <StyledListItemButton key={video.id} onClick={() => setCurrentVideo(video)}>
//           <ListItemIcon sx={{ minWidth: 'auto', mr: 1 }}>
//             <Checkbox edge="start" checked={video.completed} size="medium" sx={{ color: '#3498db' }} />
//           </ListItemIcon>
//           <ListItemText primary={video.title} primaryTypographyProps={{ color: '#34495e', fontWeight: 500, fontSize: '1rem' }} />
//           <Box sx={{ width: 60, height: 40, borderRadius: 8, overflow: 'hidden', ml: 2 }}>
//             <img src={video.thumbnail} alt={video.title} style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }} />
//           </Box>
//         </StyledListItemButton>
//       ))}
//     </List>
//   </Paper>
// );

// const VideoPlayer = ({ video, onComplete }) => {
//   const [isPlaying, setIsPlaying] = useState(false);
//   const handlePlayPause = () => setIsPlaying(!isPlaying);

//   return (
//     <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
//       <Typography variant="h4" sx={{ mb: 2, color: '#2c3e50', fontWeight: 600 }}>{video.title}</Typography>
//       <VideoCardStyled>
//         <VideoCardMediaStyled image={video.thumbnail} title={video.title} onClick={handlePlayPause} />
//         <CardContent sx={{ position: 'relative' }}>
//           <PlayButtonStyled onClick={handlePlayPause} style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: 1 }}>
//             <PlayCircle size={40} color="inherit" />
//           </PlayButtonStyled>
//           <Typography variant="body1" sx={{ color: '#555', fontWeight: 500, mt: 2 }}>{isPlaying ? 'Playing' : 'Click to Play'}</Typography>
//         </CardContent>
//       </VideoCardStyled>
//       {!video.completed && (
//         <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.3, duration: 0.3 }}>
//           <Button variant="contained" color="success" onClick={() => onComplete(video.id)} sx={{ mt: 3 }}>
//             Mark as Completed
//           </Button>
//         </motion.div>
//       )}
//     </motion.div>
//   );
// };

// const UserProfileSection = ({ user }) => (
//   <UserProfileCard>
//     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//       <Avatar src={user.avatar} alt={user.name} sx={{ width: 60, height: 60 }} />
//       <div>
//         <Typography variant="h5" sx={{ color: '#2c3e50', fontWeight: 600 }}>{user.name}</Typography>
//         <Typography variant="body2" sx={{ color: '#7f8c8d' }}>
//           <Grade sx={{ mr: 0.5, verticalAlign: 'middle', fontSize: '1rem' }} /> Level: {user.level}
//         </Typography>
//         <Typography variant="body2" sx={{ color: '#7f8c8d' }}>
//           <Person sx={{ mr: 0.5, verticalAlign: 'middle', fontSize: '1rem' }} /> Points: {user.points}
//         </Typography>
//       </div>
//     </Box>
//     <div style={{ marginTop: '1rem' }}>
//       <LinearProgress variant="determinate" value={(user.points / 500) * 100} sx={{ height: 10, borderRadius: 5 }} />
//       <Typography variant="caption" sx={{ color: '#7f8c8d', textAlign: 'right' }}>
//         {user.points} / 500 to next level
//       </Typography>
//     </div>
//   </UserProfileCard>
// );

// const CommunitySection = () => (
//     <Paper sx={{ mt: 4, p: 3, borderRadius: 12, backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' }}>
//       <Typography variant="h5" sx={{ mb: 2, color: '#34495e', fontWeight: 600, textAlign: 'center' }}>
//         <Users sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.2rem' }} /> Community
//       </Typography>
//       <Box sx={{ padding: '1.5rem', borderRadius: '8px', backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0' }}>
//         <Typography variant="body1" sx={{ color: '#555' }}>Join the discussion!</Typography>
//         <div style={{ marginTop: '1rem' }}>
//           <textarea placeholder="Your comment..." style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #e0e0e0', backgroundColor: '#fff', color: '#555', resize: 'none', minHeight: '4rem', fontSize: '1rem' }} />
//           <Button variant="contained" sx={{ mt: 2 }}>
//             <MessageRounded sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1rem' }} /> Post
//           </Button>
//         </div>
//       </Box>
//     </Paper>
// );

// const FunFactSection = () => {
//   const facts = [
//     "Brain processes images in 13ms.",
//     "Bees recognize faces!",
//     "Octopuses have 3 hearts.",
//     "Flamingos: a flamboyance.",
//     "Eiffel Tower grows in summer.",
//   ];
//   const [fact, setFact] = useState(facts[0]);

//   useEffect(() => {
//     const id = setInterval(() => setFact(facts[Math.floor(Math.random() * facts.length)]), 5000);
//     return () => clearInterval(id);
//   }, [facts]);

//   return (
//     <FunFactPaper>
//       <Typography variant="h5" sx={{ color: '#2c3e50', fontWeight: 600, textAlign: 'center' }}>
//         <Lightbulb sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.2rem' }} /> Fun Fact!
//       </Typography>
//       <Typography variant="body2" sx={{ color: '#555', fontStyle: 'italic', textAlign: 'center' }}>
//         {fact}
//       </Typography>
//     </FunFactPaper>
//   );
// };

// const VideoCoursePage = () => {
//   const [videos, setVideos] = useState(mockVideos);
//   const [currentVideo, setCurrentVideo] = useState(videos[0]);
//   const isXs = useMediaQuery(theme.breakpoints.down('sm'));

//   useEffect(() => {
//     const fetchData = async () => {
//       setTimeout(() => setVideos(mockVideos), 1000);
//     };
//     fetchData();
//   }, []);

//   const handleVideoComplete = (id) => {
//     const updateVideoStatus = async (videoId) => {
//       setVideos((prevVideos) =>
//         prevVideos.map((video) =>
//           video.id === videoId ? { ...video, completed: true } : video
//         )
//       );
//     };

//     updateVideoStatus(id);
//   };

//   const completedCount = videos.filter((v) => v.completed).length;
//   const progress = (completedCount / videos.length) * 100;

//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{ padding: isXs ? 2 : 4, minHeight: '100vh', backgroundColor: theme.palette.background.default }}>
//         <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
//           <LinearProgress variant="determinate" value={progress} sx={{ mb: 2 }} />
//           <Typography variant="subtitle1" sx={{ mb: 2, color: theme.palette.text.secondary, fontWeight: 500 }}>
//             {completedCount} / {videos.length} completed
//           </Typography>
//           <Title variant="h1">Learn UI/UX</Title>
//         </motion.div>

//         <Grid container spacing={isXs ? 2 : 4}>
//           <Grid item xs={12} md={8}>
//             <VideoPlayer video={currentVideo} onComplete={handleVideoComplete} />
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Grid container spacing={isXs ? 2 : 4}>
//               <Grid item xs={12}>
//                 <VideoList videos={videos} setCurrentVideo={setCurrentVideo} />
//               </Grid>
//               <Grid item xs={12}>
//                 <UserProfileSection user={mockUser} />
//               </Grid>
//               <Grid item xs={12}>
//                 <CommunitySection />
//               </Grid>
//               <Grid item xs={12}>
//                 <CertificateSection completedCount={completedCount} required={3} />
//               </Grid>
//               <Grid item xs={12}>
//                 <FunFactSection />
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default VideoCoursePage;



// import React, { useState, useEffect, useRef } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//   CheckCircle,
//   PlayCircleOutline as PlayCircle,
//   EmojiEvents as Trophy,
//   MenuBook as Book,
//   Group as Users,
//   Person,
//   Grade,
//   Lightbulb,
//   MessageRounded,
//   Fullscreen,
//   FullscreenExit,
//   PlayArrowRounded,
//   PauseRounded,
//   FastForwardRounded,
//   ReplayRounded,
// } from '@mui/icons-material';
// import {
//   Typography,
//   LinearProgress,
//   Grid,
//   Paper,
//   Button,
//   List,
//   ListItemButton,
//   ListItemText,
//   ListItemIcon,
//   Checkbox,
//   Card,
//   CardContent,
//   CardMedia,
//   Avatar,
//   Box,
//   IconButton,
//   Tooltip,
// } from '@mui/material';
// import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import ReactPlayer from 'react-player';

// // Mock data
// const mockCourseStructure = [
//   {
//     title: 'Introduction to UI Design',
//     duration: '5:30',
//     items: [
//       { id: 'intro-1', title: 'What is UI?', duration: '2:15', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4' },
//       { id: 'intro-2', title: 'Key Principles', duration: '3:15', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4' },
//     ],
//   },
//   {
//     title: 'Tools of the Trade',
//     duration: '8:45',
//     items: [
//       { id: 'tools-1', title: 'Introduction to Figma', duration: '4:00', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4' },
//       { id: 'tools-2', title: 'Exploring Adobe XD', duration: '4:45', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnIce.mp4' },
//     ],
//   },
//   {
//     title: 'Core UI Elements',
//     duration: '12:00',
//     items: [
//       { id: 'elements-1', title: 'Buttons and Controls', duration: '5:00', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4' },
//       { id: 'elements-2', title: 'Typography in UI', duration: '4:30', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4' },
//       { id: 'elements-3', title: 'Color and Imagery', duration: '2:30', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4' },
//     ],
//   },
// ];

// const mockUser = { name: 'Learner', avatar: 'https://placehold.co/60x60/EEE/31343C?text=AL', level: 5, points: 420 };

// // Theme
// const theme = createTheme({
//   palette: { primary: { main: '#6c63ff' }, secondary: { main: '#f44336' }, background: { default: '#f0f0f0', paper: '#ffffff' }, text: { primary: '#333', secondary: '#666' } },
//   typography: { fontFamily: '"Open Sans", sans-serif', h1: { fontWeight: 700, fontSize: '2.5rem', color: '#222' }, h2: { fontWeight: 600, fontSize: '2rem', color: '#222' }, h3: { fontWeight: 600, fontSize: '1.5rem', color: '#333' }, h4: { fontWeight: 600, fontSize: '1.2rem', color: '#444' }, h5: { fontWeight: 600, fontSize: '1rem', color: '#444' }, h6: { fontWeight: 500, fontSize: '0.9rem', color: '#555' }, body1: { fontSize: '1rem', color: '#333' }, body2: { fontSize: '0.9rem', color: '#444' }, caption: { fontSize: '0.8rem', color: '#666' }, button: { fontWeight: 600, textTransform: 'capitalize' } },
//   components: {
//     MuiButton: { styleOverrides: { root: { borderRadius: '8px', padding: '10px 20px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)', '&:hover': { boxShadow: '0 3px 7px rgba(0,0,0,0.15)' } }, contained: { backgroundColor: '#6c63ff', color: '#fff', '&:hover': { backgroundColor: '#5a52d4' } }, outlined: { borderColor: '#6c63ff', color: '#6c63ff', '&:hover': { backgroundColor: 'rgba(108, 99, 255, 0.08)' } }, text: { color: '#6c63ff', '&:hover': { backgroundColor: 'rgba(108, 99, 255, 0.08)' } }, sizeSmall: { padding: '6px 12px', fontSize: '0.8rem' }, sizeLarge: { padding: '12px 24px', fontSize: '1.1rem' } } },
//     MuiCard: { styleOverrides: { root: { borderRadius: '12px', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' } } },
//     MuiCardContent: { styleOverrides: { root: { padding: '16px' } } },
//     MuiPaper: { styleOverrides: { root: { borderRadius: '12px', boxShadow: '0 2px 6px rgba(0,0,0,0.05)', border: '1px solid #e0e0e0' } } },
//     MuiListItemButton: { styleOverrides: { root: { borderRadius: '8px', '&:hover': { backgroundColor: '#f5f5f5' } } } },
//     MuiLinearProgress: { styleOverrides: { root: { borderRadius: '8px', height: '10px' } } },
//   },
// });

// // Styled Components
// const Title = styled(Typography)(({ theme }) => ({ fontWeight: 700, color: theme.palette.primary.main, marginBottom: theme.spacing(3), textAlign: 'center', fontSize: '2.2rem' }));
// const VideoCardStyled = styled(Card)(({ theme }) => ({ transition: 'transform 0.3s, box-shadow 0.3s', '&:hover': { transform: 'scale(1.03)', boxShadow: '0 6px 18px rgba(0,0,0,0.15)' } }));
// const VideoCardMediaStyled = styled(CardMedia)({ aspectRatio: '16 / 9', borderRadius: '12px', objectFit: 'cover', cursor: 'pointer' });
// const PlayButtonStyled = styled(Button)(({ theme }) => ({ backgroundColor: '#fff', color: theme.palette.primary.main, borderRadius: '50%', width: 60, height: 60, minWidth: 0, padding: 0, boxShadow: '0 3px 7px rgba(0,0,0,0.15)', transition: 'transform 0.2s, background-color 0.2s', '&:hover': { transform: 'scale(1.1)', backgroundColor: '#f8f8f8' } }));
// const StyledListItemButton = styled(ListItemButton)(({ theme }) => ({ borderRadius: 12, margin: `${theme.spacing(0.5)} 0`, paddingRight: theme.spacing(1), transition: 'background-color 0.3s, transform 0.2s', '&:hover': { backgroundColor: '#f8f8f8', transform: 'translateX(4px)' } }));
// const CertificatePaper = styled(Paper)(({ theme }) => ({ marginTop: theme.spacing(4), padding: theme.spacing(3), textAlign: 'center', borderRadius: 12, boxShadow: '0 6px 18px rgba(0,0,0,0.15)', border: '1px solid #e0e0e0' }));
// const DownloadButton = styled(Button)(({ theme }) => ({ backgroundColor: '#4caf50', color: '#fff', '&:hover': { backgroundColor: '#43a047' }, borderRadius: 8, padding: theme.spacing(1.5, 3), fontWeight: 600 }));
// const UserProfileCard = styled(Card)(({ theme }) => ({ backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', borderRadius: 12, padding: theme.spacing(2), border: '1px solid #e0e0e0' }));
// const FunFactPaper = styled(Paper)(({ theme }) => ({ padding: theme.spacing(2), marginTop: theme.spacing(2), borderRadius: 12, boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0', backgroundColor: '#fff' }));
// const DurationText = styled(Typography)(({ theme }) => ({
//   fontSize: '0.85rem',
//   color: theme.palette.text.secondary,
//   marginLeft: theme.spacing(1),
// }));

// // New Styled Components for Video Player Controls
// const VideoControls = styled(Box)(({ theme }) => ({
//   position: 'absolute',
//   bottom: 0,
//   left: 0,
//   right: 0,
//   background: 'rgba(0, 0, 0, 0.6)',
//   color: '#fff',
//   display: 'flex',
//   alignItems: 'center',
//   padding: theme.spacing(1),
//   justifyContent: 'space-between',
//   zIndex: 2,
// }));

// const ControlButton = styled(IconButton)(({ theme }) => ({
//   color: '#fff',
//   '&:hover': {
//     color: theme.palette.primary.light,
//   },
// }));

// const TimeDisplay = styled(Typography)(({ theme }) => ({
//   fontSize: '0.9rem',
//   margin: theme.spacing(0, 1),
// }));

// const SeekBarContainer = styled(Box)({
//   flex: 1,
//   margin: '0 8px',
//   display: 'flex',
//   alignItems: 'center',
//   height: '20px',
//   position: 'relative', // Make sure the container is a positioning context
// });

// const SeekBar = styled('input')({
//   WebkitAppearance: 'none',
//   appearance: 'none',
//   backgroundColor: 'rgba(255, 255, 255, 0.3)',
//   height: '6px',
//   borderRadius: '5px',
//   outline: 'none',
//   width: '100%',
//   position: 'absolute', // Position absolutely within the container
//   top: '50%',          // Center vertically
//   transform: 'translateY(-50%)',
//   cursor: 'pointer',

//   '&::-webkit-slider-thumb': {
//     WebkitAppearance: 'none',
//     appearance: 'none',
//     backgroundColor: '#6c63ff',
//     width: '16px',
//     height: '16px',
//     borderRadius: '50%',
//     cursor: 'pointer',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//   },

//   '&::-moz-range-thumb': {
//     backgroundColor: '#6c63ff',
//     width: '16px',
//     height: '16px',
//     borderRadius: '50%',
//     cursor: 'pointer',
//     boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
//     border: 'none',
//   },

//   '&::-webkit-slider-thumb:hover, &::-moz-range-thumb:hover': {
//     transform: 'scale(1.1)',
//   },

//   '&:focus': {
//     boxShadow: '0 0 0 3px rgba(108, 99, 255, 0.3)',
//   },
// });

// const BufferBar = styled(Box)(({ theme, value }) => ({
//   position: 'absolute',
//   top: '50%',
//   left: 0,
//   height: '6px',
//   backgroundColor: 'rgba(255, 255, 255, 0.5)', // Lighter color for buffer
//   borderRadius: '5px',
//   width: `${value}%`, // Use the value prop to set the width
//   pointerEvents: 'none', // Important: Makes sure the SeekBar receives clicks
// }));

// // Components
// const CertificateSection = ({ completedCount, required }) => {
//   const isUnlocked = completedCount >= required;
//   return (
//     <CertificatePaper>
//       <Typography variant="h4" sx={{ color: '#ffc107' }}>
//         <Trophy sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.5rem' }} /> Course Certificate
//       </Typography>
//       <AnimatePresence>
//         {isUnlocked ? (
//           <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.5 }} exit={{ opacity: 0, scale: 0.5 }}>
//             <CheckCircle color="success" sx={{ fontSize: 60, mb: 2, color: '#4caf50' }} />
//             <Typography variant="h6" gutterBottom>
//               Completed {completedCount} videos.
//             </Typography>
//             <DownloadButton variant="contained">Download</DownloadButton>
//           </motion.div>
//         ) : (
//           <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.3 }} exit={{ opacity: 0, y: -20 }}>
//             <Typography variant="body1">Complete {required} videos to unlock.</Typography>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </CertificatePaper>
//   );
// };

// const VideoList = ({ videos, setCurrentVideoId, setPlayingVideoId }) => {
//   const handleVideoClick = (videoId) => {
//     setCurrentVideoId(videoId);
//     setPlayingVideoId(true); // Auto-play when a new video is selected
//   };

//   return (
//     <Paper sx={{ p: 2, borderRadius: 12, backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' }}>
//       <Typography variant="h5" sx={{ mb: 2, color: '#34495e', fontWeight: 600, textAlign: 'center' }}>
//         <Book sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.2rem' }} /> Course Content
//       </Typography>
//       <List>
//         {videos.map((video) => (
//           <StyledListItemButton key={video.id} onClick={() => handleVideoClick(video.id)}>
//             <ListItemIcon sx={{ minWidth: 'auto', mr: 1 }}>
//               <Checkbox edge="start" checked={video.completed} size="medium" sx={{ color: '#3498db' }} />
//             </ListItemIcon>
//             <ListItemText primary={video.title} primaryTypographyProps={{ color: '#34495e', fontWeight: 500, fontSize: '1rem' }} />
//             <DurationText>{video.duration}</DurationText>
//             <Box sx={{ width: 60, height: 40, borderRadius: 8, overflow: 'hidden', ml: 2 }}>
//               <img src={`https://via.placeholder.com/150/0000FF/808080?Text=${encodeURIComponent(video.title.substring(0, 2))}`} alt={video.title} style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }} />
//             </Box>
//           </StyledListItemButton>
//         ))}
//       </List>
//     </Paper>
//   );
// };

// const VideoPlayer = ({ video, onComplete, isPlaying, setIsPlaying }) => {
//   const [isFullScreen, setIsFullScreen] = useState(false);
//   const playerRef = useRef(null);
//   const playerContainerRef = useRef(null);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);
//   const [buffered, setBuffered] = useState(0);
//   const [seeking, setSeeking] = useState(false);

//   const handlePlayPause = () => setIsPlaying(!isPlaying);

//   const handleEnded = () => {
//     setIsPlaying(false);
//     onComplete(video.id);
//   };

//   const formatTime = (seconds) => {
//     if (isNaN(seconds)) return '00:00';
//     const date = new Date(seconds * 1000);
//     const mm = date.getUTCMinutes().toString().padStart(2, '0');
//     const ss = date.getSeconds().toString().padStart(2, '0');
//     return `${mm}:${ss}`;
//   };

//   const handleProgress = (state) => {
//     if (!seeking) {
//         setCurrentTime(state.playedSeconds);
//     }
//     setDuration(state.duration);
//   };

//   const handleSeekChange = (e) => {
//     const seekTime = parseFloat(e.target.value);
//     setCurrentTime(seekTime);
//     if (playerRef.current) {
//       playerRef.current.seekTo(seekTime);
//     }
//   };

//   const handleSeekMouseDown = () => {
//     setSeeking(true);
//   };

//   const handleSeekMouseUp = () => {
//     setSeeking(false);
//   };


//   const toggleFullScreen = () => {
//     if (playerContainerRef.current) {
//       if (!document.fullscreenElement) {
//         playerContainerRef.current.requestFullscreen();
//         setIsFullScreen(true);
//       } else {
//         document.exitFullscreen();
//         setIsFullScreen(false);
//       }
//     }
//   };

//   useEffect(() => {
//     const handleFullScreenChange = () => {
//       setIsFullScreen(!!document.fullscreenElement);
//     };

//     document.addEventListener('fullscreenchange', handleFullScreenChange);

//     return () => {
//       document.removeEventListener('fullscreenchange', handleFullScreenChange);
//     };
//   }, []);

//     const handleBuffer = () => {
//         if (playerRef.current && playerRef.current.getInternalPlayer()) {
//             const bufferedEnd = playerRef.current.getInternalPlayer().bufferedEnd();
//             if (duration > 0) {
//                 setBuffered((bufferedEnd / duration) * 100);
//             }
//         }
//     };


//   return (
//     <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }} ref={playerContainerRef} style={{ position: 'relative' }}>
//       <Typography variant="h4" sx={{ mb: 2, color: '#2c3e50', fontWeight: 600 }}>{video.title}</Typography>
//       <VideoCardStyled>
//         <VideoCardMediaStyled
//           image={`https://via.placeholder.com/640x360/6c63ff/fff?Text=${encodeURIComponent(video.title)}`}
//           title={video.title}
//           onClick={handlePlayPause}
//           style={{ cursor: 'pointer' }}
//         />
//         <CardContent sx={{ position: 'relative' }}>
//           <PlayButtonStyled
//             onClick={handlePlayPause}
//             style={{
//               position: 'absolute',
//               top: '50%',
//               left: '50%',
//               transform: 'translate(-50%, -50%)',
//               zIndex: 1,
//             }}
//           >
//             <PlayCircle size={40} color="inherit" />
//           </PlayButtonStyled>
//           <Typography variant="body1" sx={{ color: '#555', fontWeight: 500, mt: 2 }}>{isPlaying ? 'Playing' : 'Click to Play'}</Typography>
//           <VideoControls>
//             <Box display="flex" alignItems="center">
//               <ControlButton onClick={handlePlayPause}>
//                 {isPlaying ? <PauseRounded /> : <PlayArrowRounded />}
//               </ControlButton>
//               <TimeDisplay>
//                 {formatTime(currentTime)} / {formatTime(duration || 0)}
//               </TimeDisplay>
//               <SeekBarContainer>
//                 <BufferBar value={buffered} />
//                 <SeekBar
//                   type="range"
//                   min={0}
//                   max={duration || 100}
//                   value={currentTime}
//                   onChange={handleSeekChange}
//                   onMouseDown={handleSeekMouseDown}
//                   onMouseUp={handleSeekMouseUp}
//                   step="0.1"
//                 />
//               </SeekBarContainer>
//             </Box>
//             <ControlButton onClick={toggleFullScreen}>
//               {isFullScreen ? <FullscreenExit /> : <Fullscreen />}
//             </ControlButton>
//           </VideoControls>
//           <ReactPlayer
//             ref={playerRef}
//             url={video.url}
//             width="100%"
//             height="100%"
//             playing={isPlaying}
//             controls={false}
//             onEnded={handleEnded}
//             onProgress={handleProgress}
//             onBuffer={handleBuffer}
//             style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
//           />
//         </CardContent>
//       </VideoCardStyled>
//       {!video.completed && (
//         <motion.div initial={{ opacity: 0, scale: 0.5 }} animate={{ opacity: 1, scale: 1 }} transition={{ delay: 0.3, duration: 0.3 }}>
//           <Button variant="contained" color="success" onClick={() => onComplete(video.id)} sx={{ mt: 3 }}>
//             Mark as Completed
//           </Button>
//         </motion.div>
//       )}
//     </motion.div>
//   );
// };

// const UserProfileSection = ({ user }) => (
//   <UserProfileCard>
//     <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
//       <Avatar src={user.avatar} alt={user.name} sx={{ width: 60, height: 60 }} />
//       <div>
//         <Typography variant="h5" sx={{ color: '#2c3e50', fontWeight: 600 }}>{user.name}</Typography>
//         <Typography variant="body2" sx={{ color: '#7f8c8d' }}>
//           <Grade sx={{ mr: 0.5, verticalAlign: 'middle', fontSize: '1rem' }} /> Level: {user.level}
//         </Typography>
//         <Typography variant="body2" sx={{ color: '#7f8c8d' }}>
//           <Person sx={{ mr: 0.5, verticalAlign: 'middle', fontSize: '1rem' }} /> Points: {user.points}
//         </Typography>
//       </div>
//     </Box>
//     <div style={{ marginTop: '1rem' }}>
//       <LinearProgress variant="determinate" value={(user.points / 500) * 100} sx={{ height: 10, borderRadius: 5 }} />
//       <Typography variant="caption" sx={{ color: '#7f8c8d', textAlign: 'right' }}>
//         {user.points} / 500 to next level
//       </Typography>
//     </div>
//   </UserProfileCard>
// );

// const CommunitySection = () => (
//   <Paper sx={{ mt: 4, p: 3, borderRadius: 12, backgroundColor: '#fff', boxShadow: '0 4px 12px rgba(0,0,0,0.08)', border: '1px solid #e0e0e0' }}>
//     <Typography variant="h5" sx={{ mb: 2, color: '#34495e', fontWeight: 600, textAlign: 'center' }}>
//       <Users sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.2rem' }} /> Community
//     </Typography>
//     <Box sx={{ padding: '1.5rem', borderRadius: '8px', backgroundColor: '#f8f9fa', border: '1px solid #e0e0e0' }}>
//       <Typography variant="body1" sx={{ color: '#555' }}>Join the discussion!</Typography>
//       <div style={{ marginTop: '1rem' }}>
//         <textarea placeholder="Your comment..." style={{ width: '100%', padding: '0.75rem', borderRadius: '8px', border: '1px solid #e0e0e0', backgroundColor: '#fff', color: '#555',resize: 'none', minHeight: '4rem', fontSize: '1rem' }} />
//         <Button variant="contained" sx={{ mt: 2 }}>
//           <MessageRounded sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1rem' }} /> Post
//         </Button>
//       </div>
//     </Box>
//   </Paper>
// );

// const FunFactSection = () => {
//   const facts = [
//     "Brain processes images in 13ms.",
//     "Bees recognize faces!",
//     "Octopuses have 3 hearts.",
//     "Flamingos: a flamboyance.",
//     "Eiffel Tower grows in summer.",
//   ];
//   const [fact, setFact] = useState(facts[0]);

//   useEffect(() => {
//     const id = setInterval(() => setFact(facts[Math.floor(Math.random() * facts.length)]), 5000);
//     return () => clearInterval(id);
//   }, [facts]);

//   return (
//     <FunFactPaper>
//       <Typography variant="h5" sx={{ color: '#2c3e50', fontWeight: 600, textAlign: 'center' }}>
//         <Lightbulb sx={{ mr: 1, verticalAlign: 'middle', fontSize: '1.2rem' }} /> Fun Fact!
//       </Typography>
//       <Typography variant="body2" sx={{ color: '#555', fontStyle: 'italic', textAlign: 'center' }}>
//         {fact}
//       </Typography>
//     </FunFactPaper>
//   );
// };

// const VideoCoursePage = () => {
//   const [videos, setVideos] = useState([]);
//   const [currentVideoId, setCurrentVideoId] = useState(null);
//   const [isPlaying, setIsPlaying] = useState(false);
//   const isXs = useMediaQuery(theme.breakpoints.down('sm'));

//   useEffect(() => {
//     const flattenCourse = (data) => {
//       const videoList = [];
//       data.forEach((section) => {
//         section.items.forEach((item) => {
//           videoList.push({
//             ...item,
//             completed: false,
//             thumbnail: `https://via.placeholder.com/640x360/${Math.floor(Math.random() * 16777215).toString(16)}/fff?Text=${encodeURIComponent(item.title)}`,
//           });
//         });
//       });
//       return videoList;
//     };

//     const allVideos = flattenCourse(mockCourseStructure);
//     setVideos(allVideos);
//     setCurrentVideoId(allVideos[0]?.id); // Start with the first video, if available
//   }, []);

//   const handleVideoComplete = (id) => {
//     setVideos((prevVideos) =>
//       prevVideos.map((video) => (video.id === id ? { ...video, completed: true } : video))
//     );
//   };

//   const completedCount = videos.filter((v) => v.completed).length;
//   const progress = (completedCount / videos.length) * 100;
//   const currentVideo = videos.find((v) => v.id === currentVideoId) || videos[0];


//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{ padding: isXs ? 2 : 4, minHeight: '100vh', backgroundColor: theme.palette.background.default }}>
//         <motion.div initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
//           <LinearProgress variant="determinate" value={progress} sx={{ mb: 2 }} />
//           <Typography variant="subtitle1" sx={{ mb: 2, color: theme.palette.text.secondary, fontWeight: 500 }}>
//             {completedCount} / {videos.length} completed
//           </Typography>
//           <Title variant="h1">Learn UI/UX</Title>
//         </motion.div>

//         <Grid container spacing={isXs ? 2 : 4}>
//           <Grid item xs={12} md={8}>
//             {currentVideo && (
//               <VideoPlayer
//                 video={currentVideo}
//                 onComplete={handleVideoComplete}
//                 isPlaying={isPlaying}
//                 setIsPlaying={setIsPlaying}
//               />
//             )}
//           </Grid>
//           <Grid item xs={12} md={4}>
//             <Grid container spacing={isXs ? 2 : 4}>
//               <Grid item xs={12}>
//                 <VideoList videos={videos} setCurrentVideoId={setCurrentVideoId} setPlayingVideoId={setIsPlaying} />
//               </Grid>
//               <Grid item xs={12}>
//                 <UserProfileSection user={mockUser} />
//               </Grid>
//               <Grid item xs={12}>
//                 <CommunitySection />
//               </Grid>
//               <Grid item xs={12}>
//                 <CertificateSection completedCount={completedCount} required={3} />
//               </Grid>
//               <Grid item xs={12}>
//                 <FunFactSection />
//               </Grid>
//             </Grid>
//           </Grid>
//         </Grid>
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default VideoCoursePage;


// -----------------desgin 2------------------

// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//     CheckCircle,
//     PlayCircleOutline as PlayCircle,
//     Fullscreen,
//     FullscreenExit,
//     FastForwardRounded,
//     ReplayRounded,
//     ChevronLeftRounded,
//     ChevronRightOutlined,
//     LocalDrinkRounded,
//     Check,
//     EmojiEvents as Trophy,
//     Group as Users,
//     MessageRounded as MessageCircle,
//     Person as User,
//     Grade as Star,
//     AddCircleOutline as PlusCircle,
 
// } from '@mui/icons-material';
// import {
//   Typography,
//   LinearProgress,
//   Grid,
//   Paper,
//   Button,
//   List,
//   ListItemButton,
//   ListItemText,
//   Box,
//   IconButton,
//   Tooltip,
//   Collapse,
//   Stack,
//   Card,
//   CardContent,
//   CardHeader,
//   Avatar,
//   Badge,
//   CircularProgress
// } from '@mui/material';
// import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
// import { useTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import ReactPlayer from 'react-player';
// import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
// import PauseRoundedIcon from '@mui/icons-material/PauseRounded';
// import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
// import DoneAllRoundedIcon from '@mui/icons-material/DoneAllRounded';

// // Custom theme
// const customTheme = createTheme({
//   palette: {
//     primary: { main: '#9c27b0', light: '#d05ce3', dark: '#6a0080' }, // Purple
//     secondary: { main: '#e91e63', light: '#ff6090', dark: '#b0003a' }, // Pink
//     background: { default: '#f3e5f5', paper: '#fff' }, // Light Purple
//     text: { primary: '#37474f', secondary: '#78909c' }, // Dark Grey
//     success: { main: '#4caf50', light: '#81c784', dark: '#388e3c' },
//     warning: { main: '#ffc107', light: '#ffeb3b', dark: '#c79100' },
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
//     h5: { fontWeight: 500, marginBottom: '0.75em' },
//     subtitle1: { color: '#5c6bc0', fontStyle: 'italic' }, // Indigo
//     body2: { color: '#90a4ae' }, // Blue Grey
//     h6: { fontWeight: 600 },
//     caption: {
//       fontSize: '0.75rem',
//       color: '#9e9e9e',
//     },
//   },
//   components: {
//     MuiPaper: {
//       styleOverrides: {
//         rounded: { borderRadius: '16px' }, // More rounded
//         elevation1: { boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.08)' }, // Softer shadow
//       },
//     },
//     MuiListItemButton: {
//       styleOverrides: {
//         root: {
//           '&:hover': { backgroundColor: 'rgba(156, 39, 176, 0.08)' }, // Light Purple hover
//           paddingTop: '0.8rem', // Increased padding
//           paddingBottom: '0.8rem',
//           borderRadius: '12px', // Rounded corners
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: '12px', // More rounded buttons
//           textTransform: 'capitalize',
//           padding: '0.8rem 2rem', // Increased padding
//           boxShadow: '0 2px 5px rgba(0, 0, 0, 0.08)', // Subtle shadow
//           '&:hover': {
//             boxShadow: '0 3px 7px rgba(0, 0, 0, 0.12)', // Increased shadow on hover
//           },
//         },
//         containedPrimary: {
//           color: 'white',
//           '&:hover': { backgroundColor: '#7b1fa2' },
//         },
//         containedSecondary: {
//           color: 'white',
//           '&:hover': { backgroundColor: '#c2185b' },
//         },
//         outlined: {
//           borderColor: '#d1c4e9', // Light purple border
//           color: '#9c27b0',
//           '&:hover': {
//             backgroundColor: 'rgba(156, 39, 176, 0.04)', // Very light purple hover
//             borderColor: '#9c27b0',
//           },
//         },
//       },
//     },
//     MuiLinearProgress: {
//       styleOverrides: {
//         root: { borderRadius: '12px', height: '12px' }, // More rounded progress bar
//         bar: { backgroundColor: '#e91e63' },
//       },
//     },
//     MuiIconButton: {
//       styleOverrides: {
//         root: {
//           '&:hover': {
//             backgroundColor: 'rgba(0, 0, 0, 0.06)', // Lighter hover effect
//           },
//           borderRadius: '50%', // Make it round
//         },
//       },
//     },
//     MuiTooltip: {
//       styleOverrides: {
//         tooltip: {
//           backgroundColor: '#303030', // Darker tooltip
//           color: '#fff',
//           fontSize: '0.9rem',
//           borderRadius: '8px', // Rounded tooltip
//           padding: '0.5rem 0.8rem',
//           boxShadow: '0 2px 5px rgba(0, 0, 0, 0.2)', // Add shadow
//         },
//         arrow: {
//           color: '#303030', // Match tooltip color
//         },
//       },
//     },
//   },
// });

// // Styled Components
// const SidebarTitle = styled(Typography)(({ theme }) => ({
//   fontWeight: 600, // Stronger font weight
//   color: theme.palette.primary.main, // Use primary color
//   marginBottom: theme.spacing(3), // Increased margin
//   fontSize: '1.2rem', // Slightly larger
//   textTransform: 'uppercase', // Uppercase
//   letterSpacing: '0.05em', // Add letter spacing
// }));

// const LessonItem = styled(ListItemButton)(({ theme }) => ({
//   padding: theme.spacing(1.5, 1.2), // Increased padding
//   borderRadius: '12px', // More rounded
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'space-between',
//   transition: 'background-color 0.3s ease, transform 0.2s ease', // Smooth transition
//   '&:hover': {
//     backgroundColor: 'rgba(156, 39, 176, 0.08)', // Light Purple hover
//     transform: 'scale(1.02)', // Slight scale on hover
//   },
// }));

// const LessonItemText = styled(ListItemText)(({ theme, viewed, completed }) => ({
//   '& .MuiTypography-root': {
//     fontWeight: viewed ? 500 : 400,
//     color: completed ? theme.palette.success.main : theme.palette.text.primary,
//     transition: 'color 0.3s ease', // Smooth color transition
//   },
// }));

// const DurationText = styled(Typography)(({ theme }) => ({
//   fontSize: '0.9rem',
//   color: theme.palette.text.secondary,
//   marginLeft: theme.spacing(1.5), // Increased margin
//   transition: 'color 0.3s ease',
// }));

// const VideoPlayerContainer = styled(Paper)(({ theme }) => ({
//   position: 'relative',
//   borderRadius: '16px', // More rounded
//   overflow: 'hidden',
//   aspectRatio: '16 / 9',
//   backgroundColor: '#1a202c', // Darker background for video
//   boxShadow: theme.shadows[5], // Stronger shadow
//   transition: 'box-shadow 0.3s ease', // Add transition
//   '&:hover': {
//     boxShadow: theme.shadows[7], // Increase shadow on hover
//   },
// }));

// const PlayButtonOverlay = styled(Box)(({ theme }) => ({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   right: 0,
//   bottom: 0,
//   display: 'flex',
//   justifyContent: 'center',
//   alignItems: 'center',
//   cursor: 'pointer',
//   backgroundColor: 'rgba(0, 0, 0, 0.6)',
//   opacity: 1,
//   transition: 'opacity 0.3s ease-in-out, transform 0.2s ease', // Add transform
//   '&:hover': {
//     opacity: 0.8,
//     transform: 'scale(1.1)', // Enlarge on hover
//   },
// }));

// const VideoControls = styled(Box)(({ theme }) => ({
//   position: 'absolute',
//   bottom: 0,
//   left: 0,
//   right: 0,
//   background: 'rgba(0, 0, 0, 0.7)', // Slightly more opaque
//   color: 'white',
//   padding: theme.spacing(1.2), // Increased padding
//   display: 'flex',
//   alignItems: 'center',
//   justifyContent: 'space-between',
//   zIndex: 1,
//   transition: 'background-color 0.3s ease', // Add transition
// }));

// const TimeDisplay = styled(Typography)(({ theme }) => ({
//   fontSize: '1rem', // Larger font size
//   fontWeight: 500, // Medium font weight
//   margin: '0 1rem', // Add some margin
//   transition: 'color 0.3s ease',
// }));

// const ControlButton = styled(IconButton)(({ theme }) => ({
//   color: 'white',
//   '&:hover': {
//     color: theme.palette.secondary.light,
//     transform: 'scale(1.1)', // Add scale
//   },
//   transition: 'color 0.3s ease, transform 0.2s ease', // Add transform
// }));

// const MarkCompleteButton = styled(Button)(({ theme, completed }) => ({
//   backgroundColor: completed ? theme.palette.success.main : theme.palette.primary.main,
//   color: 'white',
//   '&:hover': {
//     backgroundColor: completed ? theme.palette.success.dark : theme.palette.primary.dark,
//   },
//   padding: '0.7rem 1.5rem',
//   borderRadius: '12px',
//   transition: 'background-color 0.3s ease',
//   boxShadow: '0 2px 5px rgba(0, 0, 0, 0.08)', // Subtle shadow
//   '&:hover': {
//     boxShadow: '0 3px 7px rgba(0, 0, 0, 0.12)', // Increased shadow on hover
//   },
// }));

// const VideoInfoSection = ({ videoInfo, onMarkComplete, completed }) => (
//   <Paper sx={{ p: 3, mt: 4, boxShadow: 2 }}>
//     <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
//       {videoInfo.title}
//     </Typography>
//     <Typography variant="subtitle1" gutterBottom sx={{ color: '#616161' }}>
//       {videoInfo.description}
//     </Typography>
//     <MarkCompleteButton
//       completed={completed}
//       onClick={onMarkComplete}
//       sx={{ mt: 2 }}
//     >
//       {completed ? (
//         <>
//           <CheckCircle sx={{ mr: 1, fontSize: '1rem' }} /> Completed
//         </>
//       ) : (
//         <>
//           <Check sx={{ mr: 1, fontSize: '1rem' }} /> Mark as Complete
//         </>
//       )}
//     </MarkCompleteButton>
//   </Paper>
// );

// const CourseSidebar = ({ courseStructure, onLessonClick, viewedVideos, completedVideos }) => {
//   const [openSection, setOpenSection] = useState(null);
//   const isXs = useMediaQuery(customTheme.breakpoints.down('sm')); // Use customTheme

//   const handleToggle = (title) => {
//     setOpenSection(openSection === title ? null : title);
//   };

//   return (
//     <Paper sx={{ p: isXs ? 2 : 3, height: 'fit-content', boxShadow: 2 }}>
//       <SidebarTitle variant="h6">Course Content</SidebarTitle>
//       <List disablePadding>
//         {courseStructure.map((section) => (
//           <Box key={section.title} sx={{ mb: 2 }}>
//             <LessonItem onClick={() => handleToggle(section.title)}>
//               <ListItemText primary={section.title} secondary={`(${section.items.length} lessons)`} />
//               <DurationText>{section.duration}</DurationText>
//               <IconButton size="small" sx={{ color: '#757575' }}>
//                 {openSection === section.title ? (
//                   <ChevronLeftRounded fontSize="small" />
//                 ) : (
//                   <ChevronRightOutlined fontSize="small" />
//                 )}
//               </IconButton>
//             </LessonItem>
//             <Collapse in={openSection === section.title} timeout="auto" unmountOnExit sx={{ mt: 0.5 }}>
//               <List component="div" disablePadding>
//                 {section.items.map((item) => {
//                   const isViewed = viewedVideos.includes(item.id);
//                   const isCompleted = completedVideos.includes(item.id);
//                   return (
//                     <ListItemButton
//                       key={item.id}
//                       sx={{ pl: 4, py: 1, borderRadius: '12px' }} // Use customTheme
//                       onClick={() => onLessonClick(item.id)}
//                     >
//                       <LessonItemText
//                         primary={item.title}
//                         viewed={isViewed}
//                         completed={isCompleted}
//                       />
//                       <Tooltip title={isCompleted ? 'Completed' : 'Not Completed'} placement="right">
//                         {isCompleted ? (
//                           <DoneAllRoundedIcon color="success" sx={{ ml: 1, fontSize: 'small' }} />
//                         ) : isViewed ? (
//                           <VisibilityOutlinedIcon color="primary" sx={{ ml: 1, fontSize: 'small' }} />
//                         ) : null}
//                       </Tooltip>
//                       <DurationText>{item.duration}</DurationText>
//                     </ListItemButton>
//                   );
//                 })}
//               </List>
//             </Collapse>
//           </Box>
//         ))}
//       </List>
//     </Paper>
//   );
// };

// const VideoPlayerArea = ({ currentVideo, onVideoEnd, onMarkComplete, completed }) => {
//   const [isPlaying, setIsPlaying] = useState(false);
//   const [currentTime, setCurrentTime] = useState(0);
//   const [duration, setDuration] = useState(0);
//   const [isFullScreen, setIsFullScreen] = useState(false);
//   const playerRef = useRef(null);
//   const playerContainerRef = useRef(null);

//   const handlePlayPause = () => {
//     setIsPlaying(!isPlaying);
//   };

//   const handleProgress = (state) => {
//     setCurrentTime(state.playedSeconds);
//     setDuration(state.duration);
//   };

//   const handleEnded = () => {
//     setIsPlaying(false);
//     onVideoEnd();
//   };

//   const handleRewind = () => {
//     if (playerRef.current) {
//       playerRef.current.seekTo(currentTime - 10, 'seconds');
//     }
//   };

//   const handleFastForward = () => {
//     if (playerRef.current) {
//       playerRef.current.seekTo(currentTime + 10, 'seconds');
//     }
//   };

//   const formatTime = (seconds) => {
//     if (isNaN(seconds)) return '00:00';
//     const date = new Date(seconds * 1000);
//     const mm = date.getUTCMinutes().toString().padStart(2, '0');
//     const ss = date.getSeconds().toString().padStart(2, '0');
//     return `${mm}:${ss}`;
//   };

//   const toggleFullScreen = () => {
//     if (playerContainerRef.current) {
//       if (!document.fullscreenElement) {
//         playerContainerRef.current.requestFullscreen();
//         setIsFullScreen(true);
//       } else {
//         document.exitFullscreen();
//         setIsFullScreen(false);
//       }
//     }
//   };

//   useEffect(() => {
//     const handleFullScreenChange = () => {
//       setIsFullScreen(!!document.fullscreenElement);
//     };

//     document.addEventListener('fullscreenchange', handleFullScreenChange);

//     return () => {
//       document.removeEventListener('fullscreenchange', handleFullScreenChange);
//     };
//   }, []);

//   return (
//     <VideoPlayerContainer ref={playerContainerRef}>
//       {currentVideo ? (
//         <>
//           <ReactPlayer
//             ref={playerRef}
//             url={currentVideo.url}
//             width="100%"
//             height="100%"
//             controls={false}
//             playing={isPlaying}
//             onProgress={handleProgress}
//             onEnded={handleEnded}
//             onPlay={() => setIsPlaying(true)}
//             onPause={() => setIsPlaying(false)}
//           />
//           {!isPlaying && (
//             <PlayButtonOverlay onClick={handlePlayPause}>
//               <PlayCircle style={{ fontSize: 90, color: 'white' }} />
//             </PlayButtonOverlay>
//           )}
//           <VideoControls>
//             <Box display="flex" alignItems="center">
//               <ControlButton onClick={handlePlayPause}>
//                 {isPlaying ? <PauseRoundedIcon style={{ fontSize: 32 }} /> : <PlayArrowRoundedIcon style={{ fontSize: 32 }} />}
//               </ControlButton>
//               <ControlButton onClick={handleRewind}>
//                 <ReplayRounded style={{ fontSize: 28 }} />
//               </ControlButton>
//               <ControlButton onClick={handleFastForward}>
//                 <FastForwardRounded style={{ fontSize: 28 }} />
//               </ControlButton>
//               <TimeDisplay>{formatTime(currentTime)} / {formatTime(duration || 0)}</TimeDisplay>
//             </Box>
//             <ControlButton onClick={toggleFullScreen}>
//               {isFullScreen ? <FullscreenExit style={{ fontSize: 28 }} /> : <Fullscreen style={{ fontSize: 28 }} />}
//             </ControlButton>
//           </VideoControls>
//         </>
//       ) : (
//         <Box
//           display="flex"
//           justifyContent="center"
//           alignItems="center"
//           height="100%"
//           color="white"
//           flexDirection="column"
//         >
//           <PlayCircle style={{ fontSize: 100, color: 'rgba(255,255,255,0.8)' }} />
//           <Typography variant="h6" sx={{ mt: 2 }}>Select a lesson to begin</Typography>
//         </Box>
//       )}
//     </VideoPlayerContainer>
//   );
// };

// // New Components

// const CourseCertificate = ({ completedVideos, totalVideos, isCertificateUnlocked }) => {
//   const [showCertificate, setShowCertificate] = useState(false);
//   const progress = (completedVideos / totalVideos) * 100;

//   return (
//     <Card sx={{ mt: 4, boxShadow: 2 }}>
//       <CardHeader
//         title="Course Certificate"
//         titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
//         avatar={<Trophy style={{ color: isCertificateUnlocked ? '#ffb300' : '#bdbdbd' }} />}
//       />
//       <CardContent>
//         {isCertificateUnlocked ? (
//           <motion.div
//             initial={{ opacity: 0, scale: 0.8 }}
//             animate={{ opacity: 1, scale: 1 }}
//             transition={{ duration: 0.5 }}
//             style={{
//               backgroundImage: 'linear-gradient(to right, #fdd835, #fbc02d)', // Gold gradient
//               padding: '2rem',
//               borderRadius: '12px',
//               color: '#333',
//               textAlign: 'center',
//               boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)',
//               border: '2px solid #f57f17', // Darker gold border
//             }}
//           >
//             <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
//               Certificate of Completion
//             </Typography>
//             <Typography variant="subtitle1" sx={{ fontStyle: 'italic', mb: 2 }}>
//               Awarded to Learner for completing the course.
//             </Typography>
//             <Typography variant="body1" sx={{ fontSize: '1.1rem' }}>
//               Congratulations on successfully completing the course!
//             </Typography>
//             {/* Add a button to view/download certificate if needed */}
//           </motion.div>
//         ) : (
//           <>
//             <Typography variant="body2" sx={{ mb: 2 }}>
//               Complete {totalVideos - completedVideos} more {totalVideos - completedVideos === 1 ? 'video' : 'videos'} to unlock your certificate.
//             </Typography>
//             <LinearProgress
//               variant="determinate"
//               value={progress}
//               sx={{ borderRadius: '12px', height: '12px' }}
//             />
//           </>
//         )}
//         <Button
//           variant="outlined"
//           color="primary"
//           onClick={() => setShowCertificate(!showCertificate)}
//           sx={{ mt: 2, width: '100%' }}
//         >
//           {showCertificate ? 'Hide Certificate' : 'View Sample Certificate'}
//         </Button>
//         <Collapse in={showCertificate}>
//           <Card sx={{ mt: 2, border: '1px solid #eee' }}>
//             <CardContent>
//               {/* Placeholder for certificate preview */}
//               <div style={{
//                 backgroundColor: '#f8f8f8',
//                 height: '150px',
//                 display: 'flex',
//                 justifyContent: 'center',
//                 alignItems: 'center',
//                 borderRadius: '8px',
//                 border: '2px dashed #ddd',
//                 color: '#aaa',
//                 fontStyle: 'italic',
//                 textAlign: 'center'
//               }}>
//                 Sample Certificate Preview
//               </div>
//             </CardContent>
//           </Card>
//         </Collapse>
//       </CardContent>
//     </Card>
//   );
// };

// const CommunitySection = () => {
//   const [posts, setPosts] = useState([
//     {
//       id: '1',
//       user: 'User1',
//       avatar: 'https://source.unsplash.com/random/50x50/?portrait&1',
//       text: 'Great course! I learned a lot about UI design.',
//       comments: 5,
//       likes: 10,
//       time: '2 hours ago',
//     },
//     {
//       id: '2',
//       user: 'User2',
//       avatar: 'https://source.unsplash.com/random/50x50/?portrait&2',
//       text: 'Has anyone used Figma for the project?',
//       comments: 12,
//       likes: 25,
//       time: '1 day ago',
//     },
//     {
//       id: '3',
//       user: 'User3',
//       avatar: 'https://source.unsplash.com/random/50x50/?portrait&3',
//       text: 'I am having trouble with color palettes. Any suggestions?',
//       comments: 8,
//       likes: 15,
//       time: '3 days ago',
//     },
//   ]);
//   const [newPostText, setNewPostText] = useState('');
//   const [isPosting, setIsPosting] = useState(false);

//   const handleAddPost = () => {
//     if (newPostText.trim() === '') return;
//     setIsPosting(true);
//     // Simulate posting delay
//     setTimeout(() => {
//       const newPost = {
//         id: String(Date.now()),
//         user: 'You', // Replace with actual user data
//         avatar: 'https://source.unsplash.com/random/50x50/?portrait&4', // Replace with user avatar
//         text: newPostText,
//         comments: 0,
//         likes: 0,
//         time: 'Just now',
//       };
//       setPosts([newPost, ...posts]);
//       setNewPostText('');
//       setIsPosting(false);
//     }, 1000);
//   };

//   return (
//     <Card sx={{ mt: 4, boxShadow: 2 }}>
//       <CardHeader
//         title="Community"
//         titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
//         avatar={<Users style={{ color: '#03a9f4' }} />}
//       />
//       <CardContent>
//         <div style={{ marginBottom: '1.5rem' }}>
//           <textarea
//             placeholder="Share your thoughts or ask a question..."
//             value={newPostText}
//             onChange={(e) => setNewPostText(e.target.value)}
//             style={{
//               width: '100%',
//               padding: '0.8rem',
//               borderRadius: '12px',
//               border: '1px solid #e0e0e0',
//               resize: 'none',
//               minHeight: '80px',
//               fontFamily: 'Roboto, sans-serif',
//               fontSize: '1rem',
//               '&:focus': {
//                 outline: 'none',
//                 borderColor: '#9c27b0',
//                 boxShadow: '0 2px 5px rgba(0, 0, 0, 0.08)',
//               },
//             }}
//             disabled={isPosting}
//           />
//           <Button
//             variant="contained"
//             color="primary"
//             onClick={handleAddPost}
//             sx={{ mt: 1, width: '100%' }}
//             disabled={isPosting}
//           >
//             {isPosting ? (
//               <>
//                 <CircularProgress className="mr-2 h-4 w-4 animate-spin" />
//                 Posting...
//               </>
//             ) : (
//               <>
//                 <PlusCircle className="mr-2 h-4 w-4" />
//                 Post
//               </>
//             )}
//           </Button>
//         </div>
//         {posts.map((post) => (
//           <div
//             key={post.id}
//             style={{
//               padding: '1.2rem',
//               borderRadius: '12px',
//               backgroundColor: '#f8f8f8',
//               marginBottom: '1.2rem',
//               border: '1px solid #eee',
//               boxShadow: '0 1px 3px rgba(0, 0, 0, 0.05)',
//             }}
//           >
//             <div style={{ display: 'flex', alignItems: 'start', marginBottom: '0.8rem' }}>
//               <Avatar src={post.avatar} alt={post.user} style={{ marginRight: '0.8rem' }} />
//               <div>
//                 <Typography variant="subtitle2" sx={{ fontWeight: 600 }}>{post.user}</Typography>
//                 <Typography variant="caption">{post.time}</Typography>
//               </div>
//             </div>
//             <Typography variant="body1" style={{ marginBottom: '0.8rem' }}>{post.text}</Typography>
//             <div style={{ display: 'flex', alignItems: 'center', color: '#757575' }}>
//               <MessageCircle style={{ marginRight: '0.3rem', height: '1rem', width: '1rem' }} />
//               <Typography variant="caption" style={{ marginRight: '1rem' }}>{post.comments} Comments</Typography>
//               <Star style={{ marginRight: '0.3rem', height: '1rem', width: '1rem' }} />
//               <Typography variant="caption">{post.likes} Likes</Typography>
//             </div>
//           </div>
//         ))}
//       </CardContent>
//     </Card>
//   );
// };

// const LearnerLevel = ({ completedVideos, totalVideos }) => {
//   const [level, setLevel] = useState(1);
//   const [points, setPoints] = useState(0);
//   const pointsPerVideo = 100;
//   const pointsToNextLevel = 500;

//   useEffect(() => {
//     const newPoints = completedVideos * pointsPerVideo;
//     setPoints(newPoints);

//     const newLevel = Math.floor(newPoints / pointsToNextLevel) + 1;
//     setLevel(newLevel);
//   }, [completedVideos]);

//   const progress = (points % pointsToNextLevel) / pointsToNextLevel * 100;

//   return (
//     <Card sx={{ mt: 4, boxShadow: 2 }}>
//       <CardHeader
//         title="Your Progress"
//         titleTypographyProps={{ variant: 'h6', fontWeight: 600 }}
//         avatar={<User style={{ color: '#4caf50' }} />}
//       />
//       <CardContent>
//         <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
//           Learner Level: {level}
//         </Typography>
//         <Typography variant="body2" sx={{ mb: 1 }}>
//           Points: {points}
//         </Typography>
//         <Typography variant="caption" sx={{ display: 'block', mb: 0.5 }}>
//           {points} / {level * pointsToNextLevel} to next level
//         </Typography>
//         <LinearProgress
//           variant="determinate"
//           value={progress}
//           sx={{ borderRadius: '12px', height: '12px' }}
//         />
//       </CardContent>
//     </Card>
//   );
// };

// const VideoCoursePage = () => {
//   const [videos, setVideos] = useState([]);
//   const [currentVideo, setCurrentVideo] = useState(null);
//   const [progress, setProgress] = useState(0);
//   const [completedVideos, setCompletedVideos] = useState(() => {
//     if (typeof window !== 'undefined') {
//       return JSON.parse(localStorage.getItem('completedVideos')) || [];
//     }
//     return [];
//   });
//   const [viewedVideos, setViewedVideos] = useState(() => {
//     if (typeof window !== 'undefined') {
//       return JSON.parse(localStorage.getItem('viewedVideos')) || [];
//     }
//     return [];
//   });

//   const isXs = useMediaQuery(customTheme.breakpoints.down('sm')); // Use customTheme
//   const [loading, setLoading] = useState(true);
//   const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
//   const totalVideos = videos.length;
//   const isCertificateUnlocked = completedVideos.length >= 3;

//   const mockCourseStructure = [
//     {
//       title: 'Introduction to UI Design',
//       duration: '5:30',
//       items: [
//         { id: 'intro-1', title: 'What is UI?', duration: '2:15', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4' },
//         { id: 'intro-2', title: 'Key Principles', duration: '3:15', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ElephantsDream.mp4' },
//       ],
//     },
//     {
//       title: 'Tools of the Trade',
//       duration: '8:45',
//       items: [
//         { id: 'tools-1', title: 'Introduction to Figma', duration: '4:00', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4' },
//         { id: 'tools-2', title: 'Exploring Adobe XD', duration: '4:45', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/SubaruOutbackOnIce.mp4' },
//       ],
//     },
//     {
//       title: 'Core UI Elements',
//       duration: '12:00',
//       items: [
//         { id: 'elements-1', title: 'Buttons and Controls', duration: '5:00', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/TearsOfSteel.mp4' },
//         { id: 'elements-2', title: 'Typography in UI', duration: '4:30', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/VolkswagenGTIReview.mp4' },
//         { id: 'elements-3', title: 'Color and Imagery', duration: '2:30', url: 'http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/WeAreGoingOnBullrun.mp4' },
//       ],
//     },
//   ];

//   const flattenCourseStructure = useCallback(() => {
//     return mockCourseStructure.reduce((acc, section) => acc.concat(section.items), []);
//   }, []);

//   const currentVideoInfo = {
//     title: currentVideo?.title || 'Welcome to the Course!',
//     description: currentVideo
//       ? `Learn about ${currentVideo.title} and enhance your UI design skills.`
//       : 'This course will guide you through the essentials of UI design. Start by selecting a lesson from the sidebar.',
//   };

//   useEffect(() => {
//     const allVideos = flattenCourseStructure();
//     setVideos(allVideos);
//     if (allVideos.length > 0 && !currentVideo) {
//       const firstUncompleted = allVideos.find((video) => !completedVideos.includes(video.id));
//       setCurrentVideo(firstUncompleted || allVideos[0]);
//       setCurrentVideoIndex(firstUncompleted ? allVideos.indexOf(firstUncompleted) : 0);
//     } else if (allVideos.length > 0 && currentVideo) {
//       setCurrentVideoIndex(allVideos.findIndex((v) => v.id === currentVideo.id));
//     }
//     setLoading(false);
//   }, [flattenCourseStructure, completedVideos, currentVideo]);

//   useEffect(() => {
//     if (typeof window !== 'undefined') {
//       localStorage.setItem('completedVideos', JSON.stringify(completedVideos));
//     }
//   }, [completedVideos]);

//   useEffect(() => {
//     if (typeof window !== 'undefined') {
//       localStorage.setItem('viewedVideos', JSON.stringify(viewedVideos));
//     }
//   }, [viewedVideos]);


//   const handleLessonClick = useCallback((videoId) => {
//     const selectedVideo = videos.find((video) => video.id === videoId);
//     if (selectedVideo) {
//       setCurrentVideo(selectedVideo);
//       setCurrentVideoIndex(videos.findIndex((v) => v.id === videoId));
//       if (!viewedVideos.includes(videoId)) {
//         setViewedVideos((prev) => {
//           const updatedViewed = [...prev, videoId];
//           return updatedViewed;
//         });
//       }
//     }
//   }, [videos, setViewedVideos]);

//   const handleVideoEnd = useCallback(() => {
//     if (!currentVideo) return;
//     if (!completedVideos.includes(currentVideo.id)) {
//       setCompletedVideos((prev) => {
//         const updatedCompleted = [...prev, currentVideo.id];
//         return updatedCompleted;
//       });
//     }
//     const nextIndex = currentVideoIndex + 1;
//     if (nextIndex < videos.length) {
//       setCurrentVideo(videos[nextIndex]);
//       setCurrentVideoIndex(nextIndex);
//     } else {
//       // Optionally handle course completion
//       alert('Congratulations! You have completed all the lessons.');
//     }
//   }, [currentVideo, currentVideoIndex, videos, completedVideos]);

//   useEffect(() => {
//     if (videos.length > 0) {
//       setProgress((completedVideos.length / videos.length) * 100);
//     }
//   }, [completedVideos, videos.length]);

//   const handleNextLesson = () => {
//     const nextIndex = currentVideoIndex + 1;
//     if (nextIndex < videos.length) {
//       setCurrentVideo(videos[nextIndex]);
//       setCurrentVideoIndex(nextIndex);
//     }
//   };

//   const handleMarkComplete = () => {
//     if (!currentVideo) return;
//     if (!completedVideos.includes(currentVideo.id)) {
//       setCompletedVideos((prev) => [...prev, currentVideo.id]);
//     }
//   };

//   return (
//     <ThemeProvider theme={customTheme}>
//       <Box sx={{ p: isXs ? 2 : 3, bgcolor: customTheme.palette.background.default, minHeight: '100vh' }}>
//         <LinearProgress
//           variant="determinate"
//           value={progress}
//           sx={{ mb: 3, borderRadius: customTheme.shape.borderRadius }} // Use customTheme
//         />
//         <Grid container spacing={isXs ? 2 : 3}>
//           <Grid item xs={12} md={8}>
//             {loading ? (
//               <Box display="flex" justifyContent="center" alignItems="center" height="400px">
//                 <LocalDrinkRounded className="animate-spin" size={70} color="primary" />
//                 <Typography sx={{ ml: 2, fontSize: '1.2rem', color: customTheme.palette.primary.main }}>Loading Course...</Typography>
//               </Box>
//             ) : (
//               <>
//                 <VideoPlayerArea
//                   currentVideo={currentVideo}
//                   onVideoEnd={handleVideoEnd}
//                   onMarkComplete={handleMarkComplete}
//                   completed={completedVideos.includes(currentVideo?.id)}
//                 />
//                 <Stack direction="row" justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     size="large"
//                     onClick={handleNextLesson}
//                     disabled={currentVideoIndex === videos.length - 1 || !currentVideo}
//                   >
//                     Next Lesson
//                   </Button>
//                 </Stack>
//                 <VideoInfoSection
//                   videoInfo={currentVideoInfo}
//                   onMarkComplete={handleMarkComplete}
//                   completed={completedVideos.includes(currentVideo?.id)}
//                 />
//               </>
//             )}
//           </Grid>
//           <Grid item xs={12} md={4}>
//             {loading ? (
//               <Paper sx={{ p: 3, height: '400px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
//                 <LocalDrinkRounded className="animate-spin" size={70} color="primary" />
//                 <Typography sx={{ ml: 2, fontSize: '1.2rem', color: customTheme.palette.primary.main }}>Loading Content...</Typography>
//               </Paper>
//             ) : (
//               <>
//                 <CourseSidebar
//                   courseStructure={mockCourseStructure}
//                   onLessonClick={handleLessonClick}
//                   viewedVideos={viewedVideos}
//                   completedVideos={completedVideos}
//                 />
//                 <CourseCertificate
//                   completedVideos={completedVideos.length}
//                   totalVideos={totalVideos}
//                   isCertificateUnlocked={isCertificateUnlocked}
//                 />
//                 <CommunitySection />
//                 <LearnerLevel completedVideos={completedVideos.length} totalVideos={totalVideos} />
//               </>
//             )}
//           </Grid>
//         </Grid>
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default VideoCoursePage;


// -----------------desgin 3------------------








// import React, { useState, useEffect, useCallback, useRef } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';
// import {
//   PlayCircle, Pause, FastForward, Rewind, Fullscreen, FullscreenExit,
//   CheckCircle, Check, ChevronRight, ChevronLeft, Trophy, Users, MessageCircle, Person, Star, AddCircle,
//   FastRewind,
//   EmojiEvents
// } from '@mui/icons-material';
// import {
//   Typography, LinearProgress, Grid, Paper, Button, List, ListItemButton,
//   ListItemText, Box, IconButton, Card, CardContent, CardHeader, Avatar,
//   TextField, Collapse, Tooltip, Badge, CircularProgress
// } from '@mui/material';
// import { styled, ThemeProvider, createTheme } from '@mui/material/styles';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import ReactPlayer from 'react-player';

// // Custom theme with purple/pink palette
// const theme = createTheme({
//   palette: {
//     primary: { main: '#7b1fa2', contrastText: '#fff' },
//     secondary: { main: '#e91e63', contrastText: '#fff' },
//     background: { default: '#f5f5f5', paper: '#fff' }
//   },
//   typography: {
//     fontFamily: '"Roboto", "Helvetica", sans-serif',
//     h5: { fontWeight: 600, fontSize: '1.5rem' },
//     h6: { fontWeight: 600, fontSize: '1.2rem' },
//     body1: { fontSize: '1rem' },
//     body2: { fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.6)' }
//   },
//   shape: { borderRadius: 12 },
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: { textTransform: 'none', fontWeight: 500, padding: '8px 16px' }
//       }
//     },
//     MuiPaper: {
//       styleOverrides: {
//         root: { boxShadow: '0 2px 10px rgba(0,0,0,0.08)' }
//       }
//     }
//   }
// });

// // Styled components
// const VideoContainer = styled('div')({
//   position: 'relative',
//   paddingTop: '56.25%', // 16:9 aspect ratio
//   backgroundColor: '#000',
//   borderRadius: theme.shape.borderRadius,
//   overflow: 'hidden',
//   '&:hover $controls': { opacity: 1 }
// });

// const Controls = styled('div')({
//   position: 'absolute',
//   bottom: 0,
//   left: 0,
//   right: 0,
//   background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
//   padding: '8px',
//   display: 'flex',
//   alignItems: 'center',
//   transition: 'opacity 0.3s',
//   zIndex: 1
// });

// const ProgressBar = styled('div')({
//   height: 4,
//   width: '100%',
//   background: 'rgba(255,255,255,0.2)',
//   position: 'relative',
//   margin: '0 8px',
//   borderRadius: 2,
//   '&:hover': { height: 6 }
// });

// const Progress = styled('div')({
//   height: '100%',
//   background: theme.palette.primary.main,
//   borderRadius: 2,
//   position: 'relative'
// });

// const Buffered = styled('div')({
//   position: 'absolute',
//   top: 0,
//   left: 0,
//   height: '100%',
//   background: 'rgba(255,255,255,0.4)',
//   borderRadius: 2
// });

// const PlayButton = styled(IconButton)({
//   color: '#fff',
//   padding: 8,
//   '&:hover': { color: theme.palette.primary.light }
// });

// const TimeDisplay = styled(Typography)({
//   color: '#fff',
//   fontSize: '0.8rem',
//   minWidth: 80,
//   textAlign: 'center'
// });

// const LessonItem = styled(ListItemButton)(({ completed }) => ({
//   borderRadius: theme.shape.borderRadius,
//   marginBottom: 4,
//   backgroundColor: completed ? 'rgba(123, 31, 162, 0.08)' : 'transparent',
//   '&:hover': { backgroundColor: 'rgba(123, 31, 162, 0.04)' }
// }));

// const CourseProgress = ({ value }) => (
//   <Box sx={{ mb: 2 }}>
//     <LinearProgress 
//       variant="determinate" 
//       value={value} 
//       sx={{ height: 8, borderRadius: 4, mb: 1 }} 
//     />
//     <Typography variant="body2" color="text.secondary" align="right">
//       {Math.round(value)}% complete
//     </Typography>
//   </Box>
// );

// const VideoPlayer = ({ url, playing, onPlay, onPause, onProgress, onEnded, onSeek }) => {
//   const playerRef = useRef(null);
//   const [duration, setDuration] = useState(0);
//   const [played, setPlayed] = useState(0);
//   const [buffered, setBuffered] = useState(0);
//   const [seeking, setSeeking] = useState(false);

//   const handleProgress = (state) => {
//     if (!seeking) {
//       setPlayed(state.playedSeconds);
//       setBuffered(state.loadedSeconds);
//       onProgress && onProgress(state);
//     }
//   };

//   const handleSeekMouseDown = () => setSeeking(true);
  
//   const handleSeekChange = (e) => {
//     const seekTo = parseFloat(e.target.value);
//     setPlayed(seekTo);
//   };

//   const handleSeekMouseUp = (e) => {
//     const seekTo = parseFloat(e.target.value);
//     playerRef.current.seekTo(seekTo);
//     setSeeking(false);
//     onSeek && onSeek(seekTo);
//   };

//   const formatTime = (seconds) => {
//     const date = new Date(seconds * 1000);
//     const hh = date.getUTCHours().toString().padStart(2, '0');
//     const mm = date.getUTCMinutes().toString().padStart(2, '0');
//     const ss = date.getSeconds().toString().padStart(2, '0');
//     return hh === '00' ? `${mm}:${ss}` : `${hh}:${mm}:${ss}`;
//   };

//   return (
//     <VideoContainer>
//       <ReactPlayer
//         ref={playerRef}
//         url={url}
//         width="100%"
//         height="100%"
//         playing={playing}
//         controls={false}
//         style={{ position: 'absolute', top: 0, left: 0 }}
//         onProgress={handleProgress}
//         onDuration={setDuration}
//         onEnded={onEnded}
//         onPlay={onPlay}
//         onPause={onPause}
//       />
      
//       {!playing && (
//         <Box sx={{
//           position: 'absolute',
//           top: 0,
//           left: 0,
//           right: 0,
//           bottom: 0,
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           backgroundColor: 'rgba(0,0,0,0.3)',
//           cursor: 'pointer'
//         }} onClick={onPlay}>
//           <PlayCircle sx={{ fontSize: 80, color: '#fff' }} />
//         </Box>
//       )}
      
//       <Controls>
//         <PlayButton onClick={playing ? onPause : onPlay}>
//           {playing ? <Pause /> : <PlayCircle />}
//         </PlayButton>
        
//         <TimeDisplay>{formatTime(played)}</TimeDisplay>
        
//         <ProgressBar>
//           <Buffered style={{ width: `${(buffered / duration) * 100}%` }} />
//           <Progress style={{ width: `${(played / duration) * 100}%` }} />
//           <input
//             type="range"
//             min={0}
//             max={duration || 100}
//             value={played}
//             onChange={handleSeekChange}
//             onMouseDown={handleSeekMouseDown}
//             onMouseUp={handleSeekMouseUp}
//             style={{
//               position: 'absolute',
//               top: -6,
//               left: 0,
//               width: '100%',
//               height: 16,
//               opacity: 0,
//               cursor: 'pointer'
//             }}
//           />
//         </ProgressBar>
        
//         <TimeDisplay>{formatTime(duration)}</TimeDisplay>
        
//         <PlayButton onClick={() => playerRef.current.seekTo(played - 10)}>
//           <FastRewind />
//         </PlayButton>
        
//         <PlayButton onClick={() => playerRef.current.seekTo(played + 10)}>
//           <FastForward />
//         </PlayButton>
//       </Controls>
//     </VideoContainer>
//   );
// };

// const CourseSidebar = ({ sections, currentVideo, onSelect, completed }) => {
//   const [expanded, setExpanded] = useState(sections.map(s => s.title));

//   const toggleSection = (title) => {
//     setExpanded(prev => 
//       prev.includes(title) 
//         ? prev.filter(t => t !== title) 
//         : [...prev, title]
//     );
//   };

//   return (
//     <Paper sx={{ p: 2 }}>
//       <Typography variant="h6" sx={{ mb: 2 }}>Course Content</Typography>
//       <List>
//         {sections.map(section => (
//           <React.Fragment key={section.title}>
//             <ListItemButton 
//               onClick={() => toggleSection(section.title)}
//               sx={{ borderRadius: 1 }}
//             >
//               <ListItemText 
//                 primary={section.title} 
//                 secondary={`${section.items.length} lessons`} 
//               />
//               {expanded.includes(section.title) ? <ChevronLeft /> : <ChevronRight />}
//             </ListItemButton>
            
//             <Collapse in={expanded.includes(section.title)}>
//               <List disablePadding>
//                 {section.items.map(item => (
//                   <LessonItem
//                     key={item.id}
//                     selected={currentVideo?.id === item.id}
//                     onClick={() => onSelect(item)}
//                     completed={completed.includes(item.id)}
//                   >
//                     <ListItemText 
//                       primary={item.title} 
//                       primaryTypographyProps={{
//                         fontWeight: currentVideo?.id === item.id ? 600 : 'normal',
//                         color: completed.includes(item.id) ? 'primary.main' : 'text.primary'
//                       }}
//                     />
//                     <Typography variant="body2" color="text.secondary">
//                       {item.duration}
//                     </Typography>
//                     {completed.includes(item.id) && (
//                       <Check color="primary" sx={{ ml: 1 }} />
//                     )}
//                   </LessonItem>
//                 ))}
//               </List>
//             </Collapse>
//           </React.Fragment>
//         ))}
//       </List>
//     </Paper>
//   );
// };

// const CommunitySection = () => {
//   const [posts, setPosts] = useState([
//     { id: 1, user: 'Alex', text: 'Great course! Learned so much about UI design.', time: '2h ago' },
//     { id: 2, user: 'Jamie', text: 'Does anyone have tips for color theory?', time: '1d ago' }
//   ]);
//   const [newPost, setNewPost] = useState('');

//   const handlePost = () => {
//     if (!newPost.trim()) return;
//     setPosts([{
//       id: Date.now(),
//       user: 'You',
//       text: newPost,
//       time: 'Just now'
//     }, ...posts]);
//     setNewPost('');
//   };

//   return (
//     <Paper sx={{ p: 2, mt: 2 }}>
//       <Typography variant="h6" sx={{ mb: 2 }}>Community</Typography>
//       <TextField
//         fullWidth
//         multiline
//         rows={3}
//         placeholder="Ask a question or share your thoughts..."
//         value={newPost}
//         onChange={(e) => setNewPost(e.target.value)}
//         sx={{ mb: 2 }}
//       />
//       <Button 
//         variant="contained" 
//         startIcon={<AddCircle />}
//         onClick={handlePost}
//         disabled={!newPost.trim()}
//       >
//         Post
//       </Button>
      
//       <Box sx={{ mt: 3 }}>
//         {posts.map(post => (
//           <Box key={post.id} sx={{ mb: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
//             <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
//               <Avatar sx={{ width: 32, height: 32, mr: 1 }}>
//                 {post.user.charAt(0)}
//               </Avatar>
//               <Typography fontWeight={600}>{post.user}</Typography>
//               <Typography variant="body2" color="text.secondary" sx={{ ml: 'auto' }}>
//                 {post.time}
//               </Typography>
//             </Box>
//             <Typography>{post.text}</Typography>
//           </Box>
//         ))}
//       </Box>
//     </Paper>
//   );
// };

// const CertificateSection = ({ progress }) => {
//   const unlocked = progress >= 100;
  
//   return (
//     <Paper sx={{ p: 2, mt: 2, textAlign: 'center' }}>
//       <EmojiEvents color={unlocked ? 'primary' : 'disabled'} sx={{ fontSize: 60, mb: 1 }} />
//       <Typography variant="h6" gutterBottom>
//         Course Certificate
//       </Typography>
      
//       {unlocked ? (
//         <>
//           <Typography color="text.secondary" sx={{ mb: 2 }}>
//             Congratulations! You've completed the course.
//           </Typography>
//           <Button variant="contained" color="primary">
//             Download Certificate
//           </Button>
//         </>
//       ) : (
//         <>
//           <Typography color="text.secondary" sx={{ mb: 2 }}>
//             Complete {Math.ceil((100 - progress) / 100 * 5)} more lessons to unlock
//           </Typography>
//           <LinearProgress 
//             variant="determinate" 
//             value={progress} 
//             sx={{ height: 8, borderRadius: 4, mb: 2 }} 
//           />
//         </>
//       )}
//     </Paper>
//   );
// };

// const VideoCoursePage = () => {
//   const isMobile = useMediaQuery(theme.breakpoints.down('md'));
//   const [sections] = useState([
//     {
//       title: 'Introduction',
//       items: [
//         { id: '1', title: 'Welcome to the Course', duration: '2:30', url: 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_1mb.mp4' },
//         { id: '2', title: 'UI Design Basics', duration: '4:15', url: 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_2mb.mp4' }
//       ]
//     },
//     {
//       title: 'Core Concepts',
//       items: [
//         { id: '3', title: 'Color Theory', duration: '5:20', url: 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_5mb.mp4' },
//         { id: '4', title: 'Typography', duration: '3:45', url: 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_10mb.mp4' }
//       ]
//     },
//     {
//       title: 'Advanced Topics',
//       items: [
//         { id: '5', title: 'Responsive Design', duration: '6:10', url: 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_20mb.mp4' },
//         { id: '6', title: 'Animations', duration: '4:50', url: 'https://sample-videos.com/video123/mp4/720/big_buck_bunny_720p_30mb.mp4' }
//       ]
//     }
//   ]);

//   const allVideos = sections.flatMap(s => s.items);
//   const [currentVideo, setCurrentVideo] = useState(allVideos[0]);
//   const [playing, setPlaying] = useState(false);
//   const [completed, setCompleted] = useState([]);
//   const [viewed, setViewed] = useState([allVideos[0].id]);
//   const [progress, setProgress] = useState(0);

//   // Calculate progress whenever completed videos change
//   useEffect(() => {
//     const newProgress = (completed.length / allVideos.length) * 100;
//     setProgress(newProgress);
//   }, [completed, allVideos.length]);

//   const handleVideoSelect = (video) => {
//     setCurrentVideo(video);
//     setPlaying(true);
//     if (!viewed.includes(video.id)) {
//       setViewed(prev => [...prev, video.id]);
//     }
//   };

//   const handleVideoEnd = () => {
//     if (!completed.includes(currentVideo.id)) {
//       setCompleted(prev => [...prev, currentVideo.id]);
//     }
//     // Auto-play next video if available
//     const currentIndex = allVideos.findIndex(v => v.id === currentVideo.id);
//     if (currentIndex < allVideos.length - 1) {
//       setCurrentVideo(allVideos[currentIndex + 1]);
//       setPlaying(true);
//     }
//   };

//   const handleMarkComplete = () => {
//     if (!completed.includes(currentVideo.id)) {
//       setCompleted(prev => [...prev, currentVideo.id]);
//     }
//   };

//   const handleNextVideo = () => {
//     const currentIndex = allVideos.findIndex(v => v.id === currentVideo.id);
//     if (currentIndex < allVideos.length - 1) {
//       setCurrentVideo(allVideos[currentIndex + 1]);
//       setPlaying(true);
//     }
//   };

//   return (
//     <ThemeProvider theme={theme}>
//       <Box sx={{ p: isMobile ? 1 : 3, bgcolor: 'background.default', minHeight: '100vh' }}>
//         <CourseProgress value={progress} />
        
//         <Grid container spacing={isMobile ? 1 : 3}>
//           <Grid item xs={12} md={8}>
//             <Paper sx={{ p: isMobile ? 1 : 2, mb: 2 }}>
//               <Typography variant="h5" gutterBottom>
//                 {currentVideo?.title || 'Select a lesson to begin'}
//               </Typography>
              
//               <VideoPlayer
//                 url={currentVideo?.url}
//                 playing={playing}
//                 onPlay={() => setPlaying(true)}
//                 onPause={() => setPlaying(false)}
//                 onEnded={handleVideoEnd}
//               />
              
//               <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
//                 <Button
//                   variant="contained"
//                   color={completed.includes(currentVideo?.id) ? 'success' : 'primary'}
//                   startIcon={<Check />}
//                   onClick={handleMarkComplete}
//                   disabled={!currentVideo || completed.includes(currentVideo.id)}
//                 >
//                   {completed.includes(currentVideo?.id) ? 'Completed' : 'Mark Complete'}
//                 </Button>
                
//                 <Button
//                   variant="outlined"
//                   onClick={handleNextVideo}
//                   disabled={!currentVideo || allVideos.findIndex(v => v.id === currentVideo.id) >= allVideos.length - 1}
//                 >
//                   Next Lesson
//                 </Button>
//               </Box>
//             </Paper>
            
//             <Paper sx={{ p: isMobile ? 1 : 2 }}>
//               <Typography variant="h6" gutterBottom>
//                 About This Lesson
//               </Typography>
//               <Typography>
//                 {currentVideo 
//                   ? `This lesson covers ${currentVideo.title.toLowerCase()}. Follow along to learn key concepts and techniques.` 
//                   : 'Select a lesson from the sidebar to begin learning.'}
//               </Typography>
//             </Paper>
//           </Grid>
          
//           <Grid item xs={12} md={4}>
//             <CourseSidebar 
//               sections={sections} 
//               currentVideo={currentVideo} 
//               onSelect={handleVideoSelect}
//               completed={completed}
//             />
            
//             <CertificateSection progress={progress} />
            
//             <CommunitySection />
//           </Grid>
//         </Grid>
//       </Box>
//     </ThemeProvider>
//   );
// };

// export default VideoCoursePage;






import React, { useState, useEffect, useCallback, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import {
  PlayCircle, Pause, FastForward, Rewind, Check, ChevronRight, ChevronLeft, EmojiEvents, AddCircle,
  FastRewindOutlined,
} from '@mui/icons-material';
import {
  Typography, LinearProgress, Grid, Paper, Button, List, ListItemButton, ListItemText, Box,
  IconButton, TextField, Collapse, CircularProgress, Alert, Avatar,
} from '@mui/material';
import { styled, ThemeProvider, createTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import ReactPlayer from 'react-player';
import axios from 'axios';
import baseUrl from '../config';

// Custom theme
const theme = createTheme({
  palette: {
    primary: { main: '#7b1fa2', contrastText: '#fff' },
    secondary: { main: '#e91e63', contrastText: '#fff' },
    background: { default: '#f5f5f5', paper: '#fff' },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", sans-serif',
    h5: { fontWeight: 600, fontSize: '1.5rem' },
    h6: { fontWeight: 600, fontSize: '1.2rem' },
    body1: { fontSize: '1rem' },
    body2: { fontSize: '0.875rem', color: 'rgba(0, 0, 0, 0.6)' },
  },
  shape: { borderRadius: 12 },
  components: {
    MuiButton: {
      styleOverrides: { root: { textTransform: 'none', fontWeight: 500, padding: '8px 16px' } },
    },
    MuiPaper: {
      styleOverrides: { root: { boxShadow: '0 2px 10px rgba(0,0,0,0.08)' } },
    },
  },
});

// Styled components (unchanged)
const VideoContainer = styled('div')({
  position: 'relative',
  paddingTop: '56.25%',
  backgroundColor: '#000',
  borderRadius: theme.shape.borderRadius,
  overflow: 'hidden',
  '&:hover $controls': { opacity: 1 },
});

const Controls = styled('div')({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  background: 'linear-gradient(transparent, rgba(0,0,0,0.7))',
  padding: '8px',
  display: 'flex',
  alignItems: 'center',
  transition: 'opacity 0.3s',
  zIndex: 1,
});

const ProgressBar = styled('div')({
  height: 4,
  width: '100%',
  background: 'rgba(255,255,255,0.2)',
  position: 'relative',
  margin: '0 8px',
  borderRadius: 2,
  '&:hover': { height: 6 },
});

const Progress = styled('div')({
  height: '100%',
  background: theme.palette.primary.main,
  borderRadius: 2,
  position: 'relative',
});

const Buffered = styled('div')({
  position: 'absolute',
  top: 0,
  left: 0,
  height: '100%',
  background: 'rgba(255,255,255,0.4)',
  borderRadius: 2,
});

const PlayButton = styled(IconButton)({
  color: '#fff',
  padding: 8,
  '&:hover': { color: theme.palette.primary.light },
});

const TimeDisplay = styled(Typography)({
  color: '#fff',
  fontSize: '0.8rem',
  minWidth: 80,
  textAlign: 'center',
});

const LessonItem = styled(ListItemButton)(({ completed }) => ({
  borderRadius: theme.shape.borderRadius,
  marginBottom: 4,
  backgroundColor: completed ? 'rgba(123, 31, 162, 0.08)' : 'transparent',
  '&:hover': { backgroundColor: 'rgba(123, 31, 162, 0.04)' },
}));

const CourseProgress = ({ value }) => (
  <Box sx={{ mb: 2 }}>
    <LinearProgress variant="determinate" value={value} sx={{ height: 8, borderRadius: 4, mb: 1 }} />
    <Typography variant="body2" color="text.secondary" align="right">
      {Math.round(value)}% complete
    </Typography>
  </Box>
);

const VideoPlayer = ({ url, playing, onPlay, onPause, onProgress, onEnded, onError }) => {
  const playerRef = useRef(null);
  const [duration, setDuration] = useState(0);
  const [played, setPlayed] = useState(0);
  const [buffered, setBuffered] = useState(0);
  const [seeking, setSeeking] = useState(false);

  const handleProgress = (state) => {
    if (!seeking) {
      setPlayed(state.playedSeconds);
      setBuffered(state.loadedSeconds);
      onProgress && onProgress(state);
    }
  };

  const handleSeekMouseDown = () => setSeeking(true);

  const handleSeekChange = (e) => {
    const seekTo = parseFloat(e.target.value);
    setPlayed(seekTo);
  };

  const handleSeekMouseUp = (e) => {
    const seekTo = parseFloat(e.target.value);
    playerRef.current.seekTo(seekTo);
    setSeeking(false);
  };

  const formatTime = (seconds) => {
    const date = new Date(seconds * 1000);
    const hh = date.getUTCHours().toString().padStart(2, '0');
    const mm = date.getUTCMinutes().toString().padStart(2, '0');
    const ss = date.getSeconds().toString().padStart(2, '0');
    return hh === '00' ? `${mm}:${ss}` : `${hh}:${mm}:${ss}`;
  };

  return (
    <VideoContainer>
      <ReactPlayer
        ref={playerRef}
        url={url}
        width="100%"
        height="100%"
        playing={playing}
        controls={false}
        style={{ position: 'absolute', top: 0, left: 0 }}
        onProgress={handleProgress}
        onDuration={setDuration}
        onEnded={onEnded}
        onPlay={onPlay}
        onPause={onPause}
        onError={onError}
      />
      {!playing && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0,0,0,0.3)',
            cursor: 'pointer',
          }}
          onClick={onPlay}
        >
          <PlayCircle sx={{ fontSize: 80, color: '#fff' }} />
        </Box>
      )}
      <Controls>
        <PlayButton onClick={playing ? onPause : onPlay}>
          {playing ? <Pause /> : <PlayCircle />}
        </PlayButton>
        <TimeDisplay>{formatTime(played)}</TimeDisplay>
        <ProgressBar>
          <Buffered style={{ width: `${(buffered / duration) * 100}%` }} />
          <Progress style={{ width: `${(played / duration) * 100}%` }} />
          <input
            type="range"
            min={0}
            max={duration || 100}
            value={played}
            onChange={handleSeekChange}
            onMouseDown={handleSeekMouseDown}
            onMouseUp={handleSeekMouseUp}
            style={{
              position: 'absolute',
              top: -6,
              left: 0,
              width: '100%',
              height: 16,
              opacity: 0,
              cursor: 'pointer',
            }}
          />
        </ProgressBar>
        <TimeDisplay>{formatTime(duration)}</TimeDisplay>
        <PlayButton onClick={() => playerRef.current.seekTo(played - 10)}>
          <FastRewindOutlined />
        </PlayButton>
        <PlayButton onClick={() => playerRef.current.seekTo(played + 10)}>
          <FastForward />
        </PlayButton>
      </Controls>
    </VideoContainer>
  );
};

const CourseSidebar = ({ sections, currentVideo, onSelect, completed }) => {
  const [expanded, setExpanded] = useState([]);

  useEffect(() => {
    setExpanded(sections.map((s) => s.title));
  }, [sections]);

  const toggleSection = (title) => {
    setExpanded((prev) => (prev.includes(title) ? prev.filter((t) => t !== title) : [...prev, title]));
  };

  return (
    <Paper sx={{ p: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Course Content</Typography>
      <List>
        {sections.map((section) => (
          <React.Fragment key={section.title}>
            <ListItemButton onClick={() => toggleSection(section.title)} sx={{ borderRadius: 1 }}>
              <ListItemText primary={section.title} secondary={`${section.items.length} lessons`} />
              {expanded.includes(section.title) ? <ChevronLeft /> : <ChevronRight />}
            </ListItemButton>
            <Collapse in={expanded.includes(section.title)}>
              <List disablePadding>
                {section.items.map((item) => (
                  <LessonItem
                    key={item.id}
                    selected={currentVideo?.id === item.id}
                    onClick={() => onSelect(item)}
                    completed={completed.includes(item.id)}
                  >
                    <ListItemText
                      primary={item.title}
                      primaryTypographyProps={{
                        fontWeight: currentVideo?.id === item.id ? 600 : 'normal',
                        color: completed.includes(item.id) ? 'primary.main' : 'text.primary',
                      }}
                    />
                    <Typography variant="body2" color="text.secondary">
                      {item.duration}
                    </Typography>
                    {completed.includes(item.id) && <Check color="primary" sx={{ ml: 1 }} />}
                  </LessonItem>
                ))}
              </List>
            </Collapse>
          </React.Fragment>
        ))}
      </List>
    </Paper>
  );
};

const CommunitySection = ({ courseId }) => {
  const [posts, setPosts] = useState([]);
  const [newPost, setNewPost] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}api/video-courses/${courseId}/community`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setPosts(response.data.posts);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load community posts.');
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, [courseId]);

  const handlePost = async () => {
    if (!newPost.trim()) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}api/video-courses/${courseId}/community`,
        { text: newPost },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      setPosts([response.data.post, ...posts]);
      setNewPost('');
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create post.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Paper sx={{ p: 2, mt: 2 }}>
      <Typography variant="h6" sx={{ mb: 2 }}>Community</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <TextField
        fullWidth
        multiline
        rows={3}
        placeholder="Ask a question or share your thoughts..."
        value={newPost}
        onChange={(e) => setNewPost(e.target.value)}
        sx={{ mb: 2 }}
      />
      <Button
        variant="contained"
        startIcon={<AddCircle />}
        onClick={handlePost}
        disabled={!newPost.trim() || loading}
      >
        {loading ? <CircularProgress size={24} /> : 'Post'}
      </Button>
      <Box sx={{ mt: 3 }}>
        {loading && <CircularProgress sx={{ display: 'block', mx: 'auto' }} />}
        {posts.map((post) => (
          <Box key={post.id} sx={{ mb: 2, p: 2, bgcolor: 'background.paper', borderRadius: 1 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <Avatar sx={{ width: 32, height: 32, mr: 1 }}>{post.user.charAt(0)}</Avatar>
              <Typography fontWeight={600}>{post.user}</Typography>
              <Typography variant="body2" color="text.secondary" sx={{ ml: 'auto' }}>
                {new Date(post.time).toLocaleString()}
              </Typography>
            </Box>
            <Typography>{post.text}</Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

const CertificateSection = ({ courseId, progress }) => {
  const [certificate, setCertificate] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchCertificate = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}api/video-courses/${courseId}/certificate`, {
        headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
      });
      setCertificate(response.data.certificate);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load certificate.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (progress >= 100) {
      fetchCertificate();
    }
  }, [progress, courseId]);

  return (
    <Paper sx={{ p: 2, mt: 2, textAlign: 'center' }}>
      <EmojiEvents color={progress >= 100 ? 'primary' : 'disabled'} sx={{ fontSize: 60, mb: 1 }} />
      <Typography variant="h6" gutterBottom>Course Certificate</Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {loading ? (
        <CircularProgress />
      ) : certificate ? (
        <>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            Congratulations! You've completed the course.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => alert(`Certificate ID: ${certificate.certificateId}`)} // Replace with actual download
          >
            Download Certificate
          </Button>
        </>
      ) : (
        <>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            Complete {Math.ceil((100 - progress) / 100 * 5)} more lessons to unlock
          </Typography>
          <LinearProgress variant="determinate" value={progress} sx={{ height: 8, borderRadius: 4, mb: 2 }} />
        </>
      )}
    </Paper>
  );
};

const VideoCoursePage = ({ courseId = '123' }) => { // courseId passed as prop or from URL
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sections, setSections] = useState([]);
  const [courseTitle, setCourseTitle] = useState('');
  const [currentVideo, setCurrentVideo] = useState(null);
  const [playing, setPlaying] = useState(false);
  const [completed, setCompleted] = useState([]);
  const [progress, setProgress] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const allVideos = sections.flatMap((s) => s.items);

  useEffect(() => {
    const fetchLessons = async () => {
      setLoading(true);
      try {
        const response = await axios.get(`${baseUrl}api/video-courses/${courseId}/lessons`, {
          headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
        });
        setSections(response.data.sections);
        setCourseTitle(response.data.courseTitle);
        setCompleted(response.data.completed);
        if (response.data.sections.length > 0) {
          setCurrentVideo(response.data.sections[0].items[0]);
        }
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to load course content.');
        if (err.response?.status === 403) {
          // Redirect to login or show enrollment prompt
          alert('Please enroll or log in to access this course.');
        }
      } finally {
        setLoading(false);
      }
    };
    fetchLessons();
  }, [courseId]);

  useEffect(() => {
    const newProgress = allVideos.length ? (completed.length / allVideos.length) * 100 : 0;
    setProgress(newProgress);
  }, [completed, allVideos.length]);

  const handleVideoSelect = async (video) => {
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}api/video-courses/${courseId}/lessons/${video.id}/play`,
        {},
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
      );
      setCurrentVideo({ ...video, url: response.data.signedUrl });
      setPlaying(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to load video.');
    } finally {
      setLoading(false);
    }
  };

  const handleVideoEnd = async () => {
    if (!completed.includes(currentVideo.id)) {
      try {
        const response = await axios.post(
          `${baseUrl}api/video-courses/${courseId}/lessons/${currentVideo.id}/complete`,
          {},
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        setCompleted(response.data.completed);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to mark lesson complete.');
      }
    }
    const currentIndex = allVideos.findIndex((v) => v.id === currentVideo.id);
    if (currentIndex < allVideos.length - 1) {
      handleVideoSelect(allVideos[currentIndex + 1]);
    }
  };

  const handleMarkComplete = async () => {
    if (!completed.includes(currentVideo.id)) {
      try {
        const response = await axios.post(
          `${baseUrl}api/video-courses/${courseId}/lessons/${currentVideo.id}/complete`,
          {},
          { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
        );
        setCompleted(response.data.completed);
      } catch (err) {
        setError(err.response?.data?.message || 'Failed to mark lesson complete.');
      }
    }
  };

  const handleNextVideo = () => {
    const currentIndex = allVideos.findIndex((v) => v.id === currentVideo.id);
    if (currentIndex < allVideos.length - 1) {
      handleVideoSelect(allVideos[currentIndex + 1]);
    }
  };

  const handleVideoError = () => {
    setError('Video failed to load. It may have expired or is unavailable.');
  };

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ p: isMobile ? 1 : 3, bgcolor: 'background.default', minHeight: '100vh' }}>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError(null)}>
            {error}
          </Alert>
        )}
        {loading && <CircularProgress sx={{ display: 'block', mx: 'auto', my: 4 }} />}
        {!loading && (
          <>
            <Typography variant="h5" gutterBottom>
              {courseTitle}
            </Typography>
            <CourseProgress value={progress} />
            <Grid container spacing={isMobile ? 1 : 3}>
              <Grid item xs={12} md={8}>
                <Paper sx={{ p: isMobile ? 1 : 2, mb: 2 }}>
                  <Typography variant="h5" gutterBottom>
                    {currentVideo?.title || 'Select a lesson to begin'}
                  </Typography>
                  <VideoPlayer
                    url={currentVideo?.url}
                    playing={playing}
                    onPlay={() => setPlaying(true)}
                    onPause={() => setPlaying(false)}
                    onEnded={handleVideoEnd}
                    onError={handleVideoError}
                  />
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
                    <Button
                      variant="contained"
                      color={completed.includes(currentVideo?.id) ? 'success' : 'primary'}
                      startIcon={<Check />}
                      onClick={handleMarkComplete}
                      disabled={!currentVideo || completed.includes(currentVideo?.id) || loading}
                    >
                      {completed.includes(currentVideo?.id) ? 'Completed' : 'Mark Complete'}
                    </Button>
                    <Button
                      variant="outlined"
                      onClick={handleNextVideo}
                      disabled={!currentVideo || allVideos.findIndex((v) => v.id === currentVideo.id) >= allVideos.length - 1}
                    >
                      Next Lesson
                    </Button>
                  </Box>
                </Paper>
                <Paper sx={{ p: isMobile ? 1 : 2 }}>
                  <Typography variant="h6" gutterBottom>About This Lesson</Typography>
                  <Typography>
                    {currentVideo
                      ? `This lesson covers ${currentVideo.title.toLowerCase()}. Follow along to learn key concepts and techniques.`
                      : 'Select a lesson from the sidebar to begin learning.'}
                  </Typography>
                </Paper>
              </Grid>
              <Grid item xs={12} md={4}>
                <CourseSidebar
                  sections={sections}
                  currentVideo={currentVideo}
                  onSelect={handleVideoSelect}
                  completed={completed}
                />
                <CertificateSection courseId={courseId} progress={progress} />
                <CommunitySection courseId={courseId} />
              </Grid>
            </Grid>
          </>
        )}
      </Box>
    </ThemeProvider>
  );
};

export default VideoCoursePage;